let platForms = window.projectImgUrl;
let skin = ''; 
if (platForms === 'amjs') {
    skin = '澳门金沙';
} else if (platForms === 'bmyl') {
    skin = '博美娱乐';
} else if (platForms === 'amxpj') {
    skin = '澳门新葡京';
} else if (platForms === 'qxyl') {
    skin = '千禧娱乐';
}
const en = {
    'titilName' : skin , //平台名
    'name' : 'data' ,
    // 首页
    'homePage' : {
        'login' : 'Log in'
    },
    // 借口返回错误码处理
    'errorCode' : {
        'loading' : 'Loading...' ,
        'webCode503' : 'Maintenance' ,
        'webDefault' : 'Request error' ,
        '4001' : 'Call remote interface exception' ,
        '401' : 'Your login account has expired, please log in again' ,
        '503' : 'System maintenance' ,
        '0' : 'success! ' ,
        '1' : 'fail! ' ,
        '500' : 'Exception!' ,
        '1001' : 'Login failed, failed to get token' ,
        '1012' : 'Network anomalies, please try again later! ' ,
        '1101' : 'User is not authorized to log in' ,
        '1102' : 'User authorization mismatch' ,
        '4011' : 'redis link exception' ,
        '4021' : 'SMS sending failed' ,
        '7001' : 'parameter exception' ,
        '7002' : 'Data parsing exception' ,
        '7011' : 'Insert parameter error' ,
        '7101' : 'The data that needs to be re-aggregated is empty' ,
        '7102' : 'Id cannot be empty' ,
        '7103' : 'The current ip is in non-CIDR format' ,
        '7201' : ' Failed to initialize verification code ' ,
        '7202' : 'Verification code verification failed, please try again' ,
        '7203' : ' Verification code cannot be empty' ,
        '7204' : 'The verification code is sent too frequently' ,
        '7301' : 'The account does not exist or has been activated, please re-enter' ,
        '7302' : 'The account has been activated, please do not activate it again' ,
        '7303' : 'The account is being activated, please do not activate it again' ,
        '7304' : 'Account does not exist' ,
        '7305' : 'The account password is incorrect, please re-enter! 3' ,
        '7306' : 'Your password modification times have reached the upper limit, please contact customer service! ' ,
        '8000' : 'No relevant data found' ,
        '9980' : 'The event has not started' ,
        '9981' : 'User level mismatch' ,
        '9983' : ' Name is required! ' ,
        '9985' : 'The level information is abnormal! ' ,
        '9987' : ' Save exception! ' ,
        '9990' : ' The automatic audit condition setting is abnormal, please confirm and try again! ' ,
        '9992' : 'The operation has taken effect, please do not repeat the operation' ,
        '9993' : 'The level setting data is abnormal, please check the level setting and try again! ' ,
        '9994' : 'No user information found' ,
        '9996' : 'User does not meet activity requirements' ,
        '9997' : 'The event has expired' ,
        '10001' : 'The event has not yet started or has ended' ,
        '10002' : 'Timer activity exception' ,
        '10003' : 'This event only allows new registered players to participate' ,
        '10004' : 'Your membership level is not within the scope of permitted participation in the event' ,
        "10006" : "The event reward collection time has not yet started or has ended" ,
        '10031' : 'The type of record cannot be modified' ,
        '10032' : 'The jump type of this record cannot be modified' ,
        '10033' : 'The jump content of this record cannot be modified' ,
        '10034' : 'The fixed code of this record cannot be modified' ,
        '10035' : 'The record cannot be deleted' ,
        '10036' : 'This event will automatically receive the highest reward, no need to apply' ,
        '10062' : 'Sign-in abnormal user does not meet the activity requirements' ,
        '10091' : 'Not participating in the manufacturer data format is abnormal, the data format is key-value format' ,
        '10501' : 'IP has been added, no need to add again' ,
        '10502' : 'When the jump type is external link , the jump content must start with http:// or https://! ' ,
        '11001' : 'Your application has been submitted, please wait for customer service to contact ' ,
        '11031' : 'Add at least one level' ,
        '11061' : 'The program is already in use and cannot be closed' ,
        '11091' : 'The proxy account may have been disabled, or deleted, or the proxy level is not a proxy' ,
        '11501' : 'The proxy account name already exists, please fill in again' ,
        '11531' : 'Commission configuration details are empty' ,
        '11801' : 'Phone number encryption failed, please try again later' ,
        '12001' : 'Failed to get game link' ,
        '12002' : 'Failed to get game link' ,
        '12003' : 'Deletion failed, there are still games under the label' ,
        '12104' : 'The game or the manufacturer has been removed' ,
        '12105' : 'The game manufacturer has not yet supported transfer confirmation' ,
        '12208' : 'No prize pool data ' ,
        '12501' : 'queryType must be one of [vendor or tags or reportFee] ' ,
        '12532' : 'Start time is required ' ,
        '12533' : 'Start time is greater than end time' ,
        '12534' : 'Start time is greater than 60 days' ,
        '12565' : 'gameKindCode cannot be empty' ,
        '12566' : 'user id does not match member id' ,
        '12592' : ' The game vendor does not have vendorCode' ,
        '12597' : 'Manufacturer information cannot be empty:' ,
        '13001' : 'User does not exist' ,
        '13002' : 'Failed to save database during user registration' ,
        '13003' : 'User check failed' ,
        '13004' : 'User status abnormal' ,
        '13006' : 'member does not exist' ,
        '13007' : 'Your account is not bound to a mobile phone number, please contact customer service ' ,
        '13008' : 'The account has been frozen, please contact customer service' ,
        '13009' : 'The account has been disabled, please contact customer service' ,
        '13010' : 'Due to the version update, your account exceeds the character limit, please contact the online customer service for processing ' ,
        '130011' : 'If the username or password is wrong, please re-enter, or contact customer service for processing ' ,
        '130012' : 'Username already exists' ,
        '13501' : 'The phone number already exists' ,
        '13502' : 'Username id cannot be empty' ,
        '13503' : 'The username of the mobile phone number is not found' ,
        '13801' : 'User registration failed' ,
        '13802' : 'User update failed' ,
        '13803' : 'Remote call user update failed' ,
        '13901' : 'The member registration settings are abnormal, please contact customer service! ' ,
        '13902' : 'The number of times the password is retrieved in the background is incorrectly configured' ,
        '14001' : 'User transfer failed' ,
        '14002' : 'Auto transfer failed' ,
        '14003' : 'The value of the two audits has changed' ,
        '14031' : 'The order is not locked yet, please lock it first before operating ' ,
        '14032' : 'The order has been locked by others and you cannot operate it! ' ,
        '14033' : 'The status of the order does not meet the requirements! ' ,
        '14034' : 'Submission failed, the exchange rate has changed, please check and confirm the amount and resubmit! ' ,
        '14061' : 'The withdrawal request has been submitted, please do not submit it again' ,
        '14062' : 'Withdrawal exception' ,
        '14091' : 'You have already bound this bank card' ,
        '14092' : 'Bank card account name cannot be empty' ,
        '14093' : 'The bound bank card has reached the upper limit' ,
        '14094' : 'The name of the bank card is inconsistent with the real name of your account' ,
        '14095' : 'The bound digital wallet has reached the upper limit' ,
        '14096' : 'The bank card cannot be deleted temporarily, please contact customer service for processing, thank you' ,
        '14097' : 'The bank card or digital wallet has been bound, please re-enter' ,
        '14098' : 'Your account is disabled, please contact customer service! ' ,
        '14099' : 'Your wallet account is disabled, please contact customer service! ' ,
        '14100' : 'The account number you entered is incorrect, please contact customer service! ' ,
        '14101' : "Please enter a wallet ID number with a length of 6 digits, thank you" ,
        '14501' : 'Depositor cannot be empty' ,
        '14502' : 'Payment platform code and name are required ' ,
        '14503' : 'Wallet user not found' ,
        '14504' : 'Your single withdrawal amount is below the lower limit:' ,
        '14505' : 'Your single withdrawal amount is higher than the upper limit:' ,
        '14506' : 'The deposit amount must be greater than zero' ,
        '14801' : 'Update failed' ,
        '14901' : 'Payment key not set' ,
        '14902' : 'The URL to get the payment list is not set' ,
        '14903' : 'The URL to get the sync order is not set' ,
        '14904' : 'The URL of the order callback is not set' ,
        '14905' : 'The recharge callback CALLBACK of digital currency is not set' ,
        '14906' : `The merchant's payment key is not set` ,
        '14907' : 'The payment related dictionary settings are wrong' ,
        '15001' : 'Collection failed' ,
        '15002' : 'Receive exception' ,
        '15034' : 'Get tenant information exception' ,
        '15035' : 'Data has been changed, roll back the transaction manually ' ,
        '15036' : 'Participation limit has been reached' ,
        '15037' : 'The total amount of participation has reached the upper limit' ,
        '15038' : 'Single amount has exceeded the upper limit' ,
        '15061' : 'The national rebate function has not been opened' ,
        '15062' : 'The amount of unclaimed rebate is less than the minimum claim amount' ,
        '15063' : 'Do not resubmit' ,
        '15064' : 'Receiving rebates' ,
        '15091' : 'The balance is being collected, no query! ! ! ' ,
        '15121' : 'Wallet service abnormal' ,
        '15151' : 'Order has been processed' ,
        '15181' : 'Failed to cleanup freeze' ,
        '15501' : 'The transfer amount must be greater than 1' ,
        '15502' : 'The transfer amount must be greater than 0' ,
        '15503' : 'The transfer mode is not a legal value' ,
        '15504' : 'Insufficient frozen balance' ,
        '15801' : 'The transfer of the central wallet to the game dealer failed ! ' ,
        '15802' : `The game merchant's transfer to the central wallet failed!` ,
        '15901' : ' Rebate is not configured' ,
        '16001' : 'Platform Maintenance' ,
        '16002' : 'Platform does not exist' ,
        '16003' : 'The account has been logged in on another device, please log in again' ,
        '100661' : 'Your sign-in request has been sent, please do not submit again' ,
        '110004' : 'Token is invalid! ' ,
        '110007' : 'User is not authorized to log in! ' ,
        '110009' : 'Current ip restricted' ,
        '110010' : 'The request is too frequent, please try again later' ,
        '120001' : 'The merchant does not exist' ,
        '120004' : 'There is null in the request parameter' ,
        '120014' : `The user's central wallet does not exist`,
        '120017' : 'Membership level does not exist' ,
        '120021' : 'Order number already exists:' ,
        '120024' : 'Order information does not match' ,
        '120025' : 'Payment pattern mismatch' ,
        '120026' : 'The status of the order has been finalized and you cannot operate it! ! ' ,
        '120027' : 'Your last withdrawal has not been processed, please be patient! ' ,
        '120029' : 'Orders need to be approved by risk control before you can operate! ' ,
        '120031' : 'Your daily withdrawals have been exhausted:' ,
        '120032' : 'Wallet has been disabled, please contact customer service! ' ,
        '120050' : 'Critical warning: The password for this user does not match' ,
        '120051' : 'Your balance is insufficient to withdraw cash! ' ,
        '120055' : ' Error generating secret value ' ,
        '120056' : 'Your withdrawal password is wrong! ' ,
        '120057' : 'Update wallet data failed version mismatch' ,
        '120070' : `The user's balance is insufficient`,
        '120093' : 'Get frequently, please try again later! ! ! ' ,
        '120561' : 'There is a problem with the invitation code you filled in (the proxy user does not exist, or has not been enabled), please verify and resubmit the application' ,
        '130000' : 'The exchange rate of this currency on the link is not found, please change the currency' ,
        '999999' : 'Payment exception' ,
        '1000' : 'Unknown error' ,
        '130013' : 'The original password is wrong, the modification failed'
},
    // Home index
    'indexPage' : {
        noMoreTipToday: 'Don\'t show up again today',
        // announcement
        'noticeMessage' : 'Announcement Notice' ,
        'more' : 'more' ,

        // Cooperation Zone

        'agencyCommission' : '50% agency commission' , // 50% agency commission
        'agencyCommissioCon1' : 'Up to 50% agency commission' ,
        'agencyCommissioCon2' : 'The commission stays at home, and the monthly income is one million' ,

        'safeAndReliable' : 'safe and secure' , // safe and secure
        'safeAndReliableCon1' : 'Monthly commission on time ' ,
        'safeAndReliableCon2' : 'Zero risk, zero risk, high reward' ,

        'preferentConstant' : 'Continuous offers' , // Continuing offers
        'preferentConstantCon1' : 'Continuous discounts throughout the year' ,
        'preferentConstantCon2' : 'Meet the needs of various types of players' ,

        'finalResource' : 'well-funded' , // well-funded
        'finalResourceCon1' : 'Withdrawal is fast and the amount is not capped' ,
        'finalResourceCon2' : 'Strong strength and guaranteed funds' ,

        'dataServices' : 'full data service' , // full data service
        'dataServicesCon1' : 'detailed information' ,
        'dataServicesCon2' : 'Betting/funding various data' ,

        'onlineLicense' : 'online license' , // online license
        'onlineLicenseCon1' : 'Video, video games, sports, lottery' ,
        'onlineLicenseCon2' : 'Online casino license, credit guarantee' ,

        'hotBrand' : 'The brand is hot' , // the brand is hot
        'hotBrandCon1' : 'Strong promotion for many years' ,
        'hotBrandCon2' : 'Agents can enjoy the brand effect of advertising' ,

        'platStable' : 'The platform has been stable for many years' , // the platform has been stable for many years
        'platStableCon1' : 'Excellent quality, service in place' ,
        'platStableCon2' : 'trusted by millions of players' ,

        // each title
        'sportEvent' : 'SPORTS EVENTS' , // popular events
        'sportEventCon' : 'Select world events to enjoy every day' ,

        'appDownload' : 'APP download' , // App download
        'appDownloadCon' : 'Self developed kernel running at high speed' ,

        'hotSports' : 'Hot sports' , // hot sports
        'hotSportsCon' : 'Bring you rich game experience' ,

        'specialOffer' : 'special offer' , // special offer
        'specialOfferCon' : 'Top mobile betting APP in the industry' ,

        'cooperZone' : 'Cooperation zone' , // cooperation zone
        'cooperZoneCon' : 'High quality service, safe and fast'

},
    homeIndex: {

        // each title

        hotgamemaintitle: 'Popular Games' ,
        hotgamesecondtitle: 'Select popular games, enjoy every day ' ,

        casinomaintitle: 'electronic games' ,
        casinosecondtitle: 'Bring you a rich gaming experience' ,

        chessmaintitle: 'chess and card entertainment' ,
        chesssecondtitle: 'Bring you a rich gaming experience' ,

        citymaintitle: 'Entertainment City' ,
        citysecondtitle: 'Bring you a rich gaming experience' ,

        coomaintitle: 'Cooperation Zone' ,
        coosecondtitle: 'High-quality service, safe and fast' ,

        hot: 'Popular' ,
        recommend: 'recommended' ,
        hotUsual: 'Frequently play' ,

        sportCom: 'Sporting Events' ,
        liveDealer: 'Live video' ,
        esportCom: 'E-sports event' ,
        lotteryCom: 'lottery game' ,

        sportComCon: 'Football, basketball, tennis, badminton and other sports have unique gameplay and accurate odds!' ,
        liveDealerCon: 'More realistic gameplay, more realistic scenes. Bring you a very exciting real game. ' ,
        esportComCon: `The world's most comprehensive e-sports quiz, allowing you to experience the feast of e-sports all the time . ` ,
        lotteryComCon: 'The sensory stimulation of lottery, a wide variety of lottery games invite you to experience together!' ,

        downApp: 'APP download' ,
        actDis: 'Promotions' ,
        cooper: 'Cooperation Zone' ,
        online: 'online service'
},
    // front page
    'indexPage' : {
        'notice' : 'Latest Announcements' ,
        'discount' : 'Promotions' ,
        'more' : 'more' ,
        'disIntro' : 'Electronic Fortune takes the lead in doing the task every day award' ,
        'viewDis' : 'View Deals' ,
        'enterLobby' : 'Enter the lobby' ,
        'casino' : 'electronic games' ,
        'live' : 'Live Entertainment' ,
        'fish' : 'fishing game' ,
        'chess' : 'chess and cards' ,
        'reviewReward' : 'Grand Prize Review' ,
        'startGame' : 'start game' ,
        'tryOnce' : 'Trial experience' ,
        'noshow' : `Don't show again`,
        'newVersion' : `Be the first to download the new ${ skin } APP! ` ,
        'text2' : 'Anti-hijacking downloads, tutorials, and rejecting false scams' ,
        'text3' : 'Deposit Operation Demo' ,
        'text4' : ` ${ skin } Official APP download, free to play as you want` ,
        'detail' : ` ✿Dear members of ${ skin } , there have always been criminals who use the name of " ${ skin } " to deceive by imitating websites, phishing websites, App web pages, WeChat public accounts, etc., please do not Be deceived to avoid losses. ${ skin } reiterates that it has no other partner companies or subsidiaries, nor has it merged with any other company. All offers on the website are subject to the official website . If you have any questions, please contact customer service! ` ,
        'gongxi' : 'Congratulations member' ,
        'zai' : 'in' ,
        'zhongjiang' : 'winner' ,
        'yuan' : 'meta' ,
        'pleaseLogin' : 'Please login' ,
        'repair' : 'Maintenance' ,
        'failed' : 'Failed to enter the game, please try again later! ' ,
},
    // secondary game
    'secondGame' : {
        'intro1' : 'On-site 360-degree viewing angle, recommend the best road' ,
        'intro2' : 'Multi- table simultaneous betting, let you have fun' ,
        'intro3' : 'Original 6-card first move, a variety of innovative ways to play' ,
        'intro4' : 'The original real person and video game play together in the same hall ' ,
        'input' : 'Please enter the game name' ,
        'newReward' : 'Latest Winning' ,
        'hot' : 'Top Picks' ,
        'member' : 'member' ,
        'reward' : 'winner' ,
        'enter' : 'Enter the game' ,
        'nothing' : 'Current input is empty' ,
        'pleaseLogin' : 'Please login' ,

},
    // Grand Prize Review
    'prize' : {
        'yuan' : 'meta' ,
        'million' : 'Million Red Packet' ,
        'like' : 'Happy red envelopes' ,
        'bet' : 'Bet Amount' ,
        'rewrad' : 'Breakout Amount' ,
},
    'enterGame' : {
        'pleaseLogin' : 'Please login' ,
},
    // Log in
    "loginPage" : {
        'memberLogin' : 'User login' , // login
        'login' : 'User login' , // login
        'account' : 'account' ,
        'password' : 'password' ,
        'verifyCode' : 'Verification Code' ,
        'accountP' : 'Please enter the account number' , // Please enter the account number
        'passwordP' : 'Please enter the login password' , // Please enter the login password
        'verifyCodeP' : 'Please enter the verification code' , // Please enter the graphic verification code
        'fastRegister' : 'register' , // register
        'retrievePassword' : 'Retrieve password' , // retrieve password
        'regain' : 'refetch' , // refetch
        'accountE' : 'Account cannot be empty' , // Account cannot be empty
        'passwordE' : 'password cannot be empty' , // password cannot be empty
        'verifyCodeE' : " Verification code cannot be empty" ,
        'firstVerify' : "Please pass the behavior verification first" , // Please pass the behavior verification first
        'loginSuccess' : "Congratulations, your login is successful" , // login successfully
        'passwordLeak' : 'Your login password has been confirmed, please change the password in time to prevent leakage! ' , // Your login password has been confirmed, please change the password in time to prevent leakage!
        'gotIt' : "I know" ,
        'logExceptionVerifyFront' : 'Your verification information is wrong, and' , // Your verification information is wrong, and
        'logExceptionVerifyBack' : ' times verification opportunities, the account will be frozen if the times are exceeded! ' , // times of verification opportunities, the account will be frozen if the times are exceeded!
        'clickBtnToVerify' : "Click the button to verify" ,
        'loading' : "Loading..." ,
        'verifySuccess' : 'Verification successful' ,
        'verifyFail' : 'Authentication failed' ,
        'getError' : 'getting error' ,
        'loadFail' : 'Load failed, please try again' ,
        'notAccount' : "No account yet?" , //No account yet?
        'fastRegister' : 'Register now' , //Register now
},
    // abnormal login verification
    'validLoginPage' : {
        'title' : 'Exception validation' ,
        'desc' : "The system detects that your account login area is abnormal, please fill in your account's real name for verification!" ,
        'realName' : 'name' ,
        'realNameP' : "Please enter your name" ,
        'submitBtn' : "Submit Verification"
},
    // register
    "registerPage" : {
        'memberRegister' : 'Member Registration' ,
        'register' : "Free account opening" ,
        'confirmPsw' : "Confirm Password" ,
        'inviteCode' : 'invitation code' ,
        'phone' : 'Mobile number' ,
        'birthday' : 'birthday' ,
        'wechat' : ' WeChat ' ,
        'qq' : 'QQ' ,
        'email' : 'mailbox' ,
        'address' : 'address' ,
        'inviteCodeP' : 'Please enter the invitation code' ,
        'optional' : '(optional)' ,
        'phoneP' : 'Please enter your mobile number' ,
        'realNameP' : 'Please enter a name' ,
        'sexP' : 'Please select a gender' ,
        'male' : 'male' ,
        'female' : 'female' ,
        'birthdayP' : 'Please enter birthday' ,
        'wechatP' : 'Please enter the WeChat ID ' ,
        'qqP' : 'Please enter the QQ number' ,
        'emailP' : 'Please enter your email address' ,
        "addressP" : 'Please enter a contact address' ,
        "agree" : 'I am over 18 years old and agree to this site' ,
        'userAgreement' : 'User Agreement' ,
        'haveAccount' : 'Already have an account? ' ,
        'fastLogin' : 'Login now' ,
        'sex' : "gender" ,
        'cancel' : "Cancel" ,
        'confirm' : 'OK' ,
        'inviteCodeE' : ' Invitation code cannot be empty! ' ,
        'confirmPswE' : 'confirm password can not be blank! ' ,
        'phoneE' : 'The phone number cannot be empty! ' ,
        'realNameE' : 'Name cannot be empty! ' ,
        'birthdayE' : 'Birthday cannot be empty! ' ,
        'wechatE' : 'Wechat ID cannot be empty! ' ,
        'qqE' : 'QQ number cannot be empty! ' ,
        'emailE' : 'E-mail can not be empty! ' ,
        'addressE' : 'Address cannot be empty! ' ,
        'codeE' : ' The verification code cannot be empty! ' ,
        'firstAgree' : 'Please check the User Agreement first! ' ,
        'inviteCodeV' : 'Invitation code must be letters or numbers' ,
        'accountV' : 'The account number must be a combination of 4~15 digits and letters' ,
        "accountPostV" : "The account number must be a combination of 4~13 digits and letters" ,
        'passwordV' : 'Password 6-15 digits, at least two combinations of alphanumeric symbols' ,
        'pswIscPsw' : 'Password and confirmation password must be the same' ,
        'phoneV' : 'The phone format is incorrect' ,
        'wechatV' : ' Wechat code does not exist! ' ,
        'qqV' : 'QQ number does not exist! ' ,
        'emailV' : 'The email address does not exist! ' ,
        'registerSuccess' : "Congratulations, your registration is successful" ,
        'inviteCodeF' : 'Please enter a letter or number'
},
    // Forgot password
    'forgetPswPage' : {
        'retrievePassword' : 'Retrieve password' ,
        'firstStep' : 'The first step: verify account information' ,
        'isRetrievePassword' : "Any questions? Please contact" ,
        'onlineService' : 'Online Customer Service' ,
        'confirmToSubmit' : "Confirm Submit" ,
        'secStep' : "Step 2: SMS Verification" ,
        'SMSCodeP' : "Please enter the SMS verification code" ,
        'getCode' : "Get verification code" ,
        'thirdStep' : 'The third step: modify the new password' ,
        'newPsw' : 'new password' ,
        'newPswP' : 'Please enter a new password' ,
        'reNewPswP' : "Please enter new password again" ,
        'codeE' : ' Verification code cannot be empty' ,
        'Tips' : 'Warm reminder' ,
        'gotIt' : 'understood' ,
        'phoneCodeE' : "SMS verification code cannot be empty!" ,
        'newPswE' : "New password cannot be empty!" ,
        'newPswValid' : 'Password 6-15 digits, at least two combinations of alphanumeric symbols' ,
        'newIsConfirmPsw' : 'The new password and the confirmation password must be the same' ,
        'modifySuccess' : 'The modification is successful, enter the login interface after 5S' ,
        'enterLogin' : 'Enter login page' ,
        'modifySuccessA' : "Modification succeeded," ,
        'aEnterLogin' : `Enter the login interface after 'S'`,
},
    // profile page
    'personalPage' : {
        'personalData' : 'Profile' ,
        'nickname' : 'nickname' ,
        'nicknameP' : 'Please enter a nickname' ,
        'submit' : 'submit' ,
        'accountPsw' : 'Account password' ,
        'tradePsw' : 'transaction password' ,
        'modify' : 'modify' ,
        'set' : 'settings' ,
        'updateSuccess' : "Update Member Successfully" ,
        'birthdayP' : 'year/month/day' ,
        'phone' : "Contact Number" ,
        'email' : "email address" ,
        'qq' : "Contact QQ"
},
    // Agent home page
    'agentHome' : {
        'title' : "Cooperation Zone" ,
        'advantage' : 'The big advantage makes you irresistible' ,
        'titleDesc' : 'High-quality service, safe and fast' ,
        'desc' : `Asia 's top online gaming company, the most credible , more high-end quality, is deeply loved and supported by the majority of players, and is committed to creating the most high-end online agency cooperation platform with zero cost and high returns. The best venture capital project for "micro-business and e-commerce". Join us and start your dream of wealth! `,
        'lang_1' : 'Eight advantages make you irresistible' ,
        'lang_21' : "Up to 50% agency commission" ,
        'lang_22' : "One million monthly income without leaving home" ,
        'lang_31' : "Monthly commission on time " ,
        'lang_32' : "Zero Risk, Zero Fee , High Return" ,
        'lang_41' : "Continuous discounts throughout the year" ,
        'lang_42' : "Meet the needs of various types of players" ,
        'lang_51' : "Withdrawal is fast and the amount is not capped" ,
        'lang_52' : "Strong strength and guaranteed funds" ,
        'lang_61' : "Detailed data information" ,
        'lang_62' : "Betting/Funding Various Data" ,
        'lang_71' : "Video, electronic games, sports, lottery" ,
        'lang_72' : "Online Casino License, Credit Guarantee" ,
        'lang_81' : "Strong promotion for many years" ,
        'lang_82' : "Agents can enjoy the brand effect of advertising" ,
        'lang_91' : "Excellent quality, good service" ,
        'lang_92' : "trusted by millions of players" ,
        'lang_2_title' : '50% agency commission' ,
        'lang_3_title' : 'safe and reliable' ,
        'lang_4_title' : 'Continuous offers' ,
        'lang_5_title' : 'Funded' ,
        'lang_6_title' : 'Comprehensive Data Services' ,
        'lang_7_title' : 'Online License' ,
        'lang_8_title' : 'The brand is very popular' ,
        'lang_9_title' : 'The platform has been stable for many years' ,
        'lang_commissionPlan' : "Agent Commission Scheme" ,
        'lang_joinUs' : "Join Us" ,
        'lang_contactService' : " Please consult customer service to join " ,
        'commissionTitle' : "Agent Commission Scheme" ,
        'contactUs' : "contact us"
},
    // proxy registration
    'agentRegister' : {
        'title' : "Agent Application" ,
        'lang_accountP' : "Please enter the application account number" ,
        'lang_passwordP' : 'Please enter the account password' ,
        'lang_rePasswordP' : "Please enter the account password again" ,
        'lang_fastApply' : 'Join now' ,
        'agreement' : "Affiliate Agreement" ,
        'accountPostF' : 'Please enter a combination of 4~13 digits and letters' ,
        'accountF' : 'Please enter a combination of 4~15 digits and letters' ,
        'passwordF' : 'Password 6-15 digits, at least two combinations of alphanumeric symbols'
},
    // Submitted successfully
    'agentResult' : {
        'applySubmited' : "Application has been submitted," ,
        'contactAttache' : 'Please contact the commissioner within 3 days to open, and provide your agent number and agent link. '
},
    // Affiliate agreement
    'agreement' : {
        'lang_title' : "[Joining Agreement]" ,
        'lang_para1' : "1. The rights and obligations of the game platform to the agency alliance:" ,
        'lang_para11' : "The customer service department of the game platform will register the members of the alliance and will observe their betting status. The alliance and members must agree to and abide by the membership regulations, policies and operating procedures of the game platform. The game platform reserves the right to refuse or freeze the affiliate/member account ." ,
        'lang_para12' : "The agent alliance can log into the interface at any time to observe the betting status of its members and the general situation of the members' activities on the website. The customer service department of the game platform will calculate the commission based on the members of the agent alliance." ,
        'lang_para13' : 'The game platform reserves the right to amend any regulations in the contract, including: the existing commission range, commission plan, payment program, and reference plan regulations. The game platform will notify the agency alliance by email, website announcement, etc. If the agent alliance has any objection to the modification, the agent alliance can choose to terminate the contract, or negotiate with the customer service staff to express their opinions. If the agency alliance has no objection after the modification, it will be regarded as a default contract modification, and the agency alliance must abide by the relevant regulations after the modification. ' ,
        'lang_para2' : "2. The rights and obligations of the agency alliance to the game platform:" ,
        'lang_para21' : 'The Agency Alliance shall do its best to widely publicize, sell and promote the game platform to maximize the profits of the agency itself and the game platform. The agency alliance can advertise, sell and promote the game platform with a positive image without violating the law, and has the responsibility to inform its members about the relevant preferential conditions and products of all game platforms. ' ,
        'lang_para22' : "If the promotion method of the game platform selected by the agent alliance requires payment, the agent shall bear the fee." ,
        'lang_para23' : "Any game platform-related information includes: logos, reports, game screens, drawings, copywriting, etc. The agency alliance shall not copy, disclose, or distribute relevant materials without permission. The game platform reserves the right of legal prosecution. If the agent has related needs for business promotion, please Feel free to contact the game platform." ,
        'lang_para3' : "Three, the rules and terms:" ,
        'lang_para31' : "Agent alliances of all levels cannot open double/multiple agent accounts without the permission of the game platform , nor can they earn commissions from the game platform account or related persons. Please keep in mind that agents of any level cannot use the agent account to bet, the game The platform reserves the right to terminate and seal the account and all commissions earned in the game." ,
        'lang_para32' : "In order to ensure the privacy and rights of all gaming platform member accounts, the gaming platform will not provide any member passwords or personal information of members. Agent alliances at all levels are also not allowed to obtain member information in any way, or log in to lower-level member accounts arbitrarily. If the privacy of members of the game platform is violated, the game platform has the right to cancel the agent alliance bonus and cancel the agent alliance account." ,
        'lang_para33' : "Members under the agency alliance shall not open more than one account . The game platform has the right to require members to provide valid identification to verify the identity of the member, and reserves the right to determine whether to duplicate members by IP. If the above matters are violated, the game platform has the right to The right to terminate the player's game and seal the account and all commissions earned in the game." ,
        'lang_para34' : "The agent alliance cannot be a valid betting member under itself or other alliances, only valid betting members directly under the company. The agent must have 3 offline valid betting members every month (at least 3 times a month to go online for normal betting), If there is a violation of the alliance agreement, the game platform has the right to terminate and seal the account and all commissions earned in the game." ,
        'lang_para35' : "If a member of the agency alliance is prohibited from enjoying the games of the game platform due to violation of the regulations, or the game platform returns the deposit to the member. The conditions in the contract will be notified by the game platform after accepting the agency alliance to join. The game platform and the agency alliance can be implemented. This contract can be terminated at any time. In any case, if the agency wants to terminate the contract, it must notify the game platform in writing/email within seven days in advance. The performance of the agency will be reviewed every 3 months. For some cooperative members, this contract can be terminated at any time. If the partner violates the contract, the game platform has the right to terminate the contract immediately." ,
        'lang_para36' : "Without the permission of the game platform, the agency alliance cannot disclose and authorize the game platform S-related confidential information, including the feedback obtained by the agency alliance, commission reports, calculations, etc.; the agency alliance is obliged to execute the confidential documents and information after the contract is terminated. Confidentiality. After the contract is terminated, the agency alliance and the game platform will not need to perform the rights and obligations of both parties. Termination of the contract will not release the agency, and the alliance should perform its obligations before terminating the contract."
},
    // announcement message
    'noticeInfo' : {
        'title' : 'Announcement message' ,
        'msgDetailTitle' : 'Notification Details' ,
        'noticeDetailTitle' : 'Announcement Details' ,
        'messageNavTitle' : 'Station letter' ,
        'noticeNavTitle' : 'announcement' ,
        'deleteAll' : 'delete all' ,
        'readedAll' : 'All read' ,
        'msgEmpty' : 'Not a single notification...' ,
        'noticeEmpty' : 'Not a single announcement...' ,
        'delete' : 'delete' ,
        'back' : 'return' ,
        'msgAllDeleteSuccess' : 'Notice all deleted successfully!' ,
        'msgAllReadSuccess' : 'Notice all read successfully!' ,
        'msgDeleteSuccess' : 'Notification deleted successfully!' ,
        'tip' : "Reminder: Messages in the station will be automatically cleared for the first 2 weeks at 10:00 am every Monday!" ,
        'sectionTitle' : "title" ,
        'time' : 'time' ,
        'status' : 'status' ,
        'operation' : 'operation' ,
        'unread' : 'unread' ,
        'readed' : "Have read"
},
    // Promotion page
    "activityPage" : {
        'return' : 'return' ,
        'title' : 'Activity Center' ,
        'longTime' : 'Long Term Activities' ,
        'limitTime' : 'Limited time event' ,
        'activityTime' : 'activity time' ,
        'ThereNOdata' : 'No more data' ,
        "actDetail" : 'Event Details' ,
        "actcomputed" : 'Activity completion' ,
        "lookList" : 'View activity log' ,
        "actList" : 'Activity Log' ,
        "yuan" : 'meta' ,
        "ongoing" : 'in progress' ,
        "unfinished" : 'unfinished' ,
        "WaitingAudit" : 'Waiting for review' ,
        "complete" : 'Completed, the reward has been issued to the central wallet' ,
        'Immediately' : 'Join Now' ,
        'Contactcustomer' : 'Contact Customer Service' ,
        'date' : 'date' ,
        "theConditions" : 'Completion condition' ,
        'completion' : 'Complete status' ,
        "month" : 'month' ,
        'day' : 'day' ,
        "Participate" : 'Participate in success' ,
        'notapproved' : 'Review failed' ,
        'Loading' : 'Loading...' ,
        'ThereNOdata' : 'No more data' ,
        'Pullmore' : ' Drop down to show more' ,
        'status' : 'active state' ,
        "actend" : 'Event Deadline' ,
        'actShuo' : 'Event Description' ,
        'title1' : 'All Offers' ,
        'title2' : 'Limited time event' ,
        'title3' : 'Long Term Activities' ,
        'title4' : 'permanent' ,
        'title5' : 'close' ,
        'hotAct' : 'Popular Events' ,
},
    // bonus page
    "lotteryGold" : {
        "LotterCollection" : "Bonus" ,
        "all" : 'all' ,
        "available" : 'Available' ,
        "Received" : 'Received' ,
        "Expired" : 'Expired' ,
        "getnow" : 'Get it now' ,
        "Validuntil" : 'Collection period expires' ,
        "nodata" : 'No data' ,
        "flowdemand" : 'Flow requirements' ,
        "bei" : ' times ' ,
        "prompt" : 'hint' ,
        "succeeded" : 'Received successfully' ,
        "toSee" : 'Please go to balance check' ,
        "Isee" : 'I got it' ,
        "beencollected" : 'The bonus has been received' ,
        "unableClaim" : 'It has expired and cannot be claimed! ' ,
        "LotterCo" : "Bonus claim" ,
        'Loading' : 'Loading...' ,
        'ThereNOdata' : 'No more data' ,
        'Pullmore' : ' Drop down to show more' ,
        'cancel' : 'Cancel'
},
    // Security center page
    'safetyPage' : {
        'loginPassword' : 'Login password' ,
        'Tomodify' : 'to modify' ,
        'WithdPassword' : 'Withdrawal password' ,
        'Tosettings' : 'go to settings' ,
        'OriginalPassword' : 'Please enter the original login password' ,
        'withdrawalPassword' : 'Please enter the original withdrawal password' ,
        'EnterOldPassword' : 'Please enter the original password' ,
        'Newloginpassword' : 'Please enter a new login password' ,
        'Newwithpassword' : 'Please enter a new withdrawal password' ,
        'Enternewpassword' : 'Please enter a new password' ,
        'Confirmnewpassword' : 'Confirm new password' ,
        'EnterPasswordAgain' : 'Please enter your password again' ,
        'SetPassword' : 'set password' ,
        "ConfirmPassword" : 'Confirm password' ,
        'Newphonenumber' : 'New phone number' ,
        'enternewnumber' : 'Please enter a new mobile number' ,
        'VerificationCode' : 'Verification Code' ,
        'entercode' : 'Please enter the verification code' ,
        'GetCaptcha' : 'Get verification code' ,
        'confirm' : 'OK' ,
        'Confirmsubmit' : 'Confirm commit' ,
        'Please contact' : 'something wrong? please contact' ,
        'OnlineService' : 'Online Customer Service' ,
        'Changepassword' : 'Modify login password' ,
        'Modifywithdpassword' : 'Modify transaction password' ,
        'Setwithdpassword' : 'Set transaction password' ,
        'Modifyphonenumber' : 'Modify mobile number' ,
        'Modifysucceeded' : 'Modified successfully' ,
        'Setupsucceeded' : 'Set successfully' ,
        'originalpassword' : 'The original password must be 6-15 digits, with at least two combinations of alphanumeric symbols' ,
        'originalwithdrawal' : 'The original withdrawal password must be 6 digits' ,
        'newwithdrawal' : 'The new withdrawal password must be 6 digits' ,
        'passwordcannotempty' : 'Original password cannot be empty' ,
        'notthesame' : 'The passwords entered twice are inconsistent' ,
        'Newpassword' : 'The new password must be 6-15 characters, at least two combinations of alphanumeric symbols' ,
        'Failednumber' : ' Failed to bind mobile number ' ,
        'Bindsuccessfully' : 'Mobile phone number binding is successful' ,
        'Mobileempty' : 'Mobile phone number cannot be empty' ,
        'IncorrectPhone' : 'The phone format is incorrect' ,
        'Failedtocode' : ' Failed to obtain mobile phone verification code ' ,
        'codecomplete' : 'Get mobile phone verification code completed ' ,
        'safeCenter' : 'Security Center' ,
        'newPass' : 'new password' ,
        "oldPass" : 'original password' ,
        'aggin' : 'Enter again' ,
        'Loginsuc' : 'Modify login password successfully' ,
        "Transactionsuc" : 'Set transaction password successfully' ,
        'ransactionsuc' : 'Change transaction password successfully' ,
        'tip' : 'Reminder: Please remember your fund password after modification. ' ,
        'tip1' : 'Current password of funds you are using' ,
        'tip2' : '6-digit combination' ,
        'tip3' : 'must match the new password' ,
        'tip4' : 'Password must be 6 digits! ' ,
        'tip5' : 'The current login password you are using' ,
        'tip6' : 'Password 6-15 digits, at least two combinations of alphanumeric symbols' ,
        'tip7' : 'Reminder: Please remember your login password after modification. ' ,
        'tip9' : 'forgot password' ,
        "tip10" : 'Your Account Security Level' ,
        "tip11" : 'also' ,
        "tip12" : 'Item not verified/configured' ,
        "tip13" : 'Funding password' ,
        "tip14" : 'After the bank card is bound, the fund password needs to be confirmed during the withdrawal operation to improve the security of your funds. ' ,
        "tip15" : 'Bind Email' ,
        "tip16" : 'modify' ,
        "tip17" : 'settings' ,
        "tip18" : 'Bind Email' ,
        "tip19" : 'Binding the mailbox can increase the security level of the account, and can also ensure that the login password can be retrieved when the mailbox is normal. ' ,
        "tip20" : 'Bind mobile phone' ,
        "tip21" : 'After binding with your account, you can strengthen your account security at important moments such as fund withdrawal and password modification. ' ,
        "tip22" : 'Bind QQ' ,
        "tip23" : 'Please contact customer service to modify! ' ,
        "tip24" : 'low-level' ,
        "tip25" : 'Advanced' ,
        "tip26" : 'medium' ,
        'tip27' : 'bound' ,
        'tip28' : 'unbound' ,
        'tip29' : 'Security Authentication' ,
        'tip30' : 'Funding password' ,
        'tip31' : 'Login password' ,
        'tip32' : 'Device Management' ,



},
    // sign in
    "signIn" : {
        'limitTime' : 'Limited time offer' ,
        'noShow' : `Don't pop up this prompt again`,
        "signIn" : 'Sign in' ,
        "actTime" : 'activity time' ,
        "to" : 'to' ,
        "di" : 'Section' ,
        "day" : 'day' ,
        "Signnow" : 'Sign in now' ,
        "Checkin" : 'Sign in to receive' ,
        "requirements" : 'Flow requirements' ,
        "bei" : ' times ' ,
        "gitNow" : 'Get it now' ,
        "tip" : 'hint' ,
        "success" : 'The claim is successful, please go to the balance to check' ,
        "Isee" : 'I got it' ,
        "actDet" : 'Event Description' ,
        "loading" : 'Loading' ,
        'long' : 'long term' ,
        'cancel' : 'Cancel' ,
        'lianxu' : 'You have checked in consecutively' ,
},
    // personal center
    "myPage" : {
        "recharge" : "Financial Center" ,
        "drawing" : "Transaction History" ,
        "highRebate" : "National Rebate" ,
        "information" : "Profile" ,
        "mode" : "Self-Service Offer" ,
        "report" : "Game Record" ,
        "security" : "Transaction History" ,
        "Notice" : "announcement message" ,
        "cooperation" : "Activity Log" ,
        "gle" : "Security Management" ,
        "withdrawals" : "Bonus Management" ,
        "Deposit" : "Member Deposit" ,
        treasure: "Interest Treasure" ,
        Rebate: "Rebate" ,
        bank: 'Payment method management' ,
        drawing: 'Member Withdrawal' ,
        userInfo: 'Basic Information' ,
        complete: 'Complete information' ,
        "water" : " Cumulative Rebate " ,
        "element" : "yuan" ,
        "full" : "full" ,
        "rec" : "Yuan can be received" ,
        "receive" : "receive" ,
        "getBackwater" : " Rebate Rewards " ,
        "once" : "Get it now" ,
        "see" : "View Details" ,
        "tipErr" : "The rebate amount does not meet the conditions and cannot be claimed!" ,
        "tipstitle" : "Warm reminder" ,
        "know" : "I know" ,
        titleAlert: 'Received successfully' ,
        "tipsRes" : "Please go to the central wallet to check the balance " ,
        "success" : " Rebate refreshed successfully" ,
        "failure" : " Failed to refresh the rebate quota , please try again!" ,
        requirements: "Flow Requirements" ,
        Times: " times " ,
        get: 'receive'
},
    // top up
    "rechargePage" : {
        "headerTitle" : "Deposit" ,
        "null" : "There is no deposit method at this time" ,
        getMode: 'Payment method' ,
        "passageway" : "Recharge Channel" ,
        "seleBank" : "Select Bank" ,
        "name" : "Deposit Name" ,
        "tipsName" : "The account has not arrived in time, please be sure to enter the correct deposit name" ,
        "inputName" : "Please enter deposit name" ,
        'address': 'Deposit Address',
        'addressPlaceholder': 'Please enter the deposit address',
        'tipsAddress': 'Did not arrive in time, please be sure to enter the correct deposit address',
        "setmoney" : "Recharge Amount" ,
        "inputMoney" : "Please enter the deposit amount" ,
        "minMoney" : "Single minimum deposit amount" ,
        "element" : "yuan" ,
        "maxMoney" : "Maximum deposit amount" ,
        "tipstitle" : "Warm reminder" ,
        "tips1" : "1. Please pay attention to the minimum transfer amount displayed on the page, recharges less than the minimum recharge amount will not be credited and cannot be refunded;" ,
        "tips2" : "2. After you recharge to the above address, you need the confirmation of the entire network node, please wait patiently, we will immediately credit the corresponding amount to your account after receiving the digital currency, if you haven't received it for a long time, you can contact customer service for consultation " ,
        "tips3" : "3. Please be sure to check the currency and chain name when transferring money. If you submit the wrong asset, you cannot get it back." ,
        "tips4" : "4. The exchange rate displayed on the page is for reference only. Due to fluctuations in the exchange rate, the account will be calculated based on the latest exchange rate ratio." ,
        "confirm" : "Confirm recharge" ,
        "next" : "Next" ,
        "setparagraph" : "Company Deposit" ,
        "online" : "Online Deposit" ,
        "currency" : "Digital Currency" ,
        "vip" : "VIP Exclusive" ,
        "tipsnull" : "There is currently no recharge information, please contact customer service!" ,
        "gotIt" : "I know" ,
        "determine" : "OK" ,
        "range" : "Amount entered out of range" ,
        "retry" : "The channel is unavailable, please try again " ,
        "error" : "error code" ,
        "bankSelect" : "Please select a bank card" ,
        errortext: 'Load failed' ,
        tipsMoney: 'Reminder: If the current payment method fails to pay successfully, please try other payment methods to pay! ' ,
},
    // withdraw money
    "accountPage" : {
        "headerTitle" : "Withdrawal" ,
        "balance" : "Account Balance" ,
        "element" : "yuan" ,
        "collection" : "One-click collection" ,
        "getMode" : "Please select a withdrawal method" ,
        "tipsnull" : "I don't even have a bank card" ,
        "addMode" : "Add withdrawal method" ,
        "addbank" : "Add bank card/digital currency" ,
        "addMoney" : "Add digital currency wallet" ,
        "cancel" : "Cancel" ,
        "more" : "more" ,
        "down" : "Pull to refresh" ,
        "away" : "put away" ,
        "warning" : "Click the interval 10s, do not repeat the operation!" ,
        "Refresh" : "Refresh balance succeeded" ,
        "hand" : "Concentration" ,
        "handRes" : "Successful collection!" ,
        "handErr" : "Failed to collect, please try again!" ,
        "setpassword" : "You haven't set a transaction password, do you want to go to settings?" ,
        "forward" : "Go now" ,
        "tipsbank" : "You can only bind up to 3 bank cards! If you need to adjust, please contact customer service!" ,
        "tipsM" : "You can only bind up to 3 digital currencies! If you need to adjust, please contact customer service!" ,
        "tipsW" : "You can only bind up to 3 origo wallets! If you need to adjust, please contact customer service!" ,
        "addWallet" : "Add origo wallet" ,
        wallet: "origo wallet" ,
        next: 'Next' ,
        phoneget: 'Please verify your mobile phone number to withdraw money' ,
        phone: 'Mobile number' ,
        inputPhone: 'Please enter your phone number' ,
        inputcode: 'Please enter the verification code' ,
        code: 'Verification Code' ,
        determine: 'OK' ,
        getcode: 'Get verification code' ,
        getmoneyMode: 'Payment method' ,
        phoneErr: 'Mobile phone number format error' ,
        getcodeSuee: 'Get the verification code successfully ' ,
        'mobile' : 'Binding mobile phone number successfully' ,
        game: 'Game Platform' ,
        accountMoney: 'Main account limit'
},
    // withdraw money
    "drawingPage" : {
        "headerTitle" : "Withdrawal" ,
        "getbank" : "Withdrawal bank card" ,
        "getMoney" : "Withdrawal Amount" ,
        "all" : "all" ,
        "sure" : "Current withdrawal amount" ,
        "element" : "yuan" ,
        "actual" : "Actual Receipt Amount" ,
        "refresh" : "refresh" ,
        "procedures" : "Withdrawal Fee" ,
        "expenses" : "Administrative Expenses" ,
        "discount" : "Preferential deduction" ,
        "pawss" : "Transaction Password" ,
        "inputPwass" : "Please enter the transaction password" ,
        "problem" : "Any questions? Please contact online customer service" ,
        "withdrawal" : "Confirm Withdrawal" ,
        "selectBank" : "Select Bank" ,
        "inputMoney" : "Please enter the withdrawal amount" ,
        "integer" : "Withdrawal amount must be a positive integer" ,
        "confirmation" : "Are you sure about the withdrawal?" ,
        "cancel" : "Cancel" ,
        "determine" : "OK" ,
        "successful" : "The application is successful, please wait for the platform to review" ,
        "fail" : "Withdrawal failed, please try again" ,
        "beyond" : "The amount exceeds the limit, please enter the correct amount" ,
        "currency" : "Digital Currency Wallet" ,
        "wallet" : "origo wallet" ,
        "getpwass" : "Retrieve password" ,
        "selecurrency" : "Choose a digital currency" ,
        "Insufficient" : "Your balance is insufficient to withdraw cash!" ,
        "lower" : "Your withdrawal limit is lower than the single withdrawal limit:" ,
        "higher" : "Your withdrawal limit is higher than the single withdrawal limit" ,
        "toolow" : "Your actual amount is too low to withdraw cash!" ,
        "minAmount" : "Minimum Withdrawal Amount" ,
        'gotIt' : 'understood' ,
        'sucRefresh' : 'Refresh successful' ,
        "tip" : 'hint' ,
        "tips1" : "1. Please pay attention to the minimum transfer amount displayed on the page, recharges less than the minimum recharge amount will not be credited and cannot be refunded;" ,
        "tips2" : "2. After you recharge to the above address, you need the confirmation of the entire network node, please wait patiently, we will immediately credit the corresponding amount to your account after receiving the digital currency, if you haven't received it for a long time, you can contact customer service for consultation " ,
        "tips3" : "3. Please be sure to check the currency and chain name when transferring money. If you submit the wrong asset, you cannot get it back." ,
        "tips4" : "4. The exchange rate displayed on the page is for reference only. Due to fluctuations in the exchange rate, the account will be calculated based on the latest exchange rate ratio." ,
        mode: 'Withdrawal method' ,
        goback: 'previous' ,
        errorTips: 'Your wallet has been frozen, please contact customer service! ' ,
        nullbank: 'No bank card added' ,
        now: 'add now'
},
    // bank card list
    "bankCardPage" : {
        "title" : "Payment Management" ,
        "tipnull" : "Here is empty \ nnothing " ,
        "addMethod" : "My bank card" ,
        "addBank" : "Add bank card" ,
        "addMoney" : "Add digital currency" ,
        "wallet" : "Add origo wallet" ,
        "wallets" : "origo wallet" ,
        "addBankmode" : "Payment Method" ,
        "username" : "Account Name" ,
        "inputName" : "Please enter account name" ,
        "bankName" : "Bank Name" ,
        "bankCode" : "Bank Card Number" ,
        "inputCode" : "Please enter your new bank card number" ,
        "tipsCode" : "Bank card number must be more than 12 digits and less than 19 digits" ,
        "branch" : "branch name" ,
        "inputbranch" : "Please enter the branch name" ,
        "Submit" : "Confirm Submit" ,
        "getcode" : "Get verification code" ,
        "selectBank" : "Please select a bank" ,
        "selectBank1" : "Select Bank" ,
        "determine" : "OK" ,
        "addRes" : "Added successfully" ,
        "addTitle" : "Digital Currency" ,
        "type" : "Select currency" ,
        "name" : "chain name" ,
        "adress" : "Wallet Address" ,
        "add" : "Confirm Add" ,
        "seleType" : "Please select a currency type" ,
        "tipName" : "Please fill in your real name and then add a bank card" ,
        "tipsPawss" : "Please set the withdrawal password first and then add the bank card" ,
        "again" : "re-add" ,
        "input" : "Please enter" ,
        "pType" : "Please select a currency" ,
        "inputAddress" : "Please enter wallet address" ,
        "linkAddress" : "Please enter the link address" ,
        "account" : "origo wallet account" ,
        "inputWallet" : "Please enter wallet account" ,
        "tipsTitle" : "hint" ,
        tips1: 'In order for your funds to arrive quickly, please ensure that the selected currency name and chain name are correct' ,
        tips2: 'In order for your funds to arrive quickly, please make sure that the name you fill in is the same as the name of the bank account' ,
        addMode: 'Add payment method' ,
        bankcard: 'bank card' ,
        cancel: 'Cancel' ,
        code2: 'Confirm card number' ,
        bankcode2: 'Please enter your bank card number again' ,
        bankcode3: 'Consists of 12-19 digits' ,
        back: 'return' ,
        text1: 'Do not add the same bank repeatedly' ,
        text2: 'Do not add the same wallet repeatedly' ,
        tips: 'Reminder: After locking the bank card, the relevant information of the bank cannot be modified (the account opening name cannot be modified, otherwise the money cannot be withdrawn!)' ,
        errCode: 'The bank card number entered twice is inconsistent' ,
        errwalletcode: 'Please enter a wallet ID number with a length of 6 digits, thank you' ,
        phone: 'Mobile number' ,
        phonecode: 'Verification Code' ,
        phoneInput: 'Please enter your phone number' ,
        codeInput: 'Please enter the verification code' ,
        'phoneEorro' : 'Mobile phone number format error' ,
        getcodeSuee: 'Get the verification code successfully ' ,

},
    //vip level
    vip: {
        level: 'VIP level' ,
        grade: 'level' ,
        reached: 'Condition fulfilled' ,
        tips: 'Number of withdrawals' ,
        deposit: 'deposit' ,
        Valid: 'Valid bet' ,
        Times: 'time' ,
        contact: 'Contact Customer Service' ,
        download: 'APP download' ,
        mobile: "Access Mobile" ,
        'maintenance' : 'Maintenance' ,
        'gotologin' : 'You are not logged in, please go to login' ,
        copy: 'copy' ,
        copyS: 'Copy successfully' ,
        copyF: 'Copy failed'
},
    header: {
        text1: 'deposit' ,
        text2: 'withdrawal' ,
        text3: 'Bonus' ,
        text4: 'My profile' ,
        text5: 'Payment method' ,
        text6: 'Game record' ,
        text7: 'Transaction history' ,
        text8: 'Announcement information' ,
        text9: 'Sign out' ,
        text10: 'Home' ,
        text11: 'sports' ,
        text12: 'Electronic' ,
        text13: 'chess and cards' ,
        text14: 'lottery' ,
        text15: 'video' ,
        text16: ' E-sports ' ,
        text17: 'Offer' ,
        login: 'login' ,
        register: 'register' ,
        VIP: 'general user'
},
    footer: {
        con: 'Government issued a license, safety is guaranteed! Support WeChat, Alipay, UnionPay services, 24-hour withdrawal, 5 minutes to the account! A legal company recognized by an international association. Please make sure you are at least 18 years old before registering and having fun ! '
},
    record: {
        text1: 'year/month/day' ,
        text2: 'query' ,
        text3: 'reset' ,
        text4: 'Not a single record...' ,
        text5: 'Copy successfully! ' ,
        text6: 'Copy failed! '
},
    gameRecord: {
        title: 'Game record' ,
        text1: 'The data of each bet will have a certain time delay, for reference only' ,
        text2: 'Game Platform:' ,
        text3: 'Please select' ,
        text4: 'Betting amount:' ,
        text5: 'Time filter:' ,
        text6: 'Single number' ,
        text7: 'copy' ,
        text8: 'Game Platform' ,
        text9: 'game name' ,
        text10: 'Bet time' ,
        text11: ' Payout Time ' ,
        text12: 'Bet Amount' ,
        text13: 'Valid bet' ,
        text14: ' Payout Amount ' ,
        text15: 'Profit and loss amount' ,
        text16: 'Total bet:' ,
        text17: 'Total payout:' ,
        text18: 'Total Effective Bet:' ,
        text19: 'Total profit and loss amount:'
},
    tradingRecord: {
        title1: 'Transaction history' ,
        title2: ' Rebate details ' ,
        text1: 'Only the transaction records of the past month can be inquired. For more information, please contact customer service to inquire.' ,
        text2: 'Transaction type:' ,
        text3: 'Transaction status:' ,
        text4: 'Transaction time:' ,
        text5: ' Rebate amount :' ,
        text6: 'Select time:' ,
        text7: 'order number' ,
        text8: 'trading hours' ,
        text9: 'amount' ,
        text10: 'status' ,
        text11: 'Payment method' ,
        text12: 'Payment successful' ,
        text13: 'Withdrawal method' ,
        text14: 'Successful payment' ,
        text15: 'type' ,
        text16: 'success' ,
        text17: 'status' ,
        text18: ' Rebate type ' ,
        text19: 'details' ,

        text20: 'activity name' ,
        text21: 'Deposit time' ,
        text22: 'interest rate' ,
        text23: 'Interest time' ,
        text24: 'amount' ,
        text25: 'interest' ,
        text26: 'Total stake and profit' ,
        text27: 'saved' ,
        text28: 'status' ,
        text29: 'operation' ,
        text30: 'time' ,
        text31: 'Game Platform' ,
        text32: 'game name' ,
        text33: 'flowing water' ,
        text34: ' Rebate ' ,
        text35: 'Interest wallet:' ,
        text36: 'Total interest received:' ,
        text37: 'Interest Treasure Collection' ,
        text38: 'includes interest' ,
        text39: 'meta' ,
        text40: 'Interest flow requirement:' ,
        text41: ' times ' ,
        text42: 'early pick up' ,
        text43: 'If you receive the quota in advance, you can only receive part of the interest. Do you confirm that you can receive it in advance? ' ,
        text44: 'Cancel' ,
        text45: 'Get it now' ,

        text46: 'today' ,
        text47: 'yesterday' ,
        text48: 'Last 7 days' ,
        text49: 'Last 30 days' ,
        text50: 'all' ,
        text51: 'In interest calculation' ,
        text52: 'Expired' ,
        text53: 'Received' ,
        text54: ' Recharge record ' ,
        text55: 'Bank transfer' ,
        text56: 'Withdrawal record' ,
        text57: ' Rebate record ' ,
        text58: 'other' ,
        text59: 'Interest Treasure' ,
        text60: 'Received successfully! ' ,
        text61: 'unhandled' ,
        text62: 'Processing' ,
        text63: ' Recharge successful ' ,
        text64: ' Recharge failed ' ,
        text65: 'close' ,
        text66: ' Pending payment ' ,
        text67: 'Paying' ,
        text68: 'Payment successful' ,
        text69: 'Payment failed' ,
        text70: 'closed' ,
        text71: 'Offline bank card payment' ,
        text72: 'Offline QR code payment ' ,
        text73: 'Online Payment' ,
        text74: ' Manually up the score' ,
        text75: 'Numerical currency payment' ,

        text76: ' Pending payment ' ,
        text77: 'Paying' ,
        text78: 'Payment successful' ,
        text79: 'Payment failed' ,
        text80: ' Alipay scan code ' ,
        text81: ' WeChat scan code ' ,
        text82: ' WeChat H5' ,
        text83: 'Alipay H5' ,
        text84: ' UnionPay scan code ' ,
        text85: 'UnionPay Transfer' ,
        text86: 'other' ,
        text87: 'unhandled' ,
        text88: 'Processing' ,
        text89: 'Withdrawal successful' ,
        text90: 'Withdrawal failed' ,
        text91: 'close' ,
        text92: 'Pending payment' ,
        text93: 'Paying out' ,
        text94: 'Successful payment' ,
        text95: 'Failed to pay out' ,
        text96: 'close' ,
        text97: 'Bank Card Withdrawal' ,
        text98: 'manually subdivide' ,
        text99: 'Numerical Currency Withdrawal Application' ,
        text100: 'origo wallet withdrawal' ,
        text101: 'unhandled' ,
        text102: 'Processing' ,
        text103: 'success' ,
        text104: 'failure' ,
        text105: 'close' ,
        text106: 'to be received' ,
        text107: 'Expired' ,
        text108: 'success' ,
        text109: 'failure' ,
        payChannel1: 'Offline Deposit Offer' ,
        payChannel2: 'Online Deposit Offer' ,
        payChannel3: ' Manually up the score' ,
        payChannel4: 'Manual deposit bonus points' ,
        payChannel5: 'Manual rebate bonus points' ,
        payChannel6: 'Manual activity promotion points' ,
        payChannel7: 'Automatic activity promotion points' ,
        payChannel8: 'Manually place points-deposit' ,
        payChannel9: 'Manual sub-points - promotions' ,
        payChannel10: 'Manual sub-division - manual deposit is reversed' ,
        payChannel11: 'Manual Subscription - Deposit Offer' ,
        payChannel12: ' Manually increase points - promotions' ,
        payChannel13: ' Manual bonus points - manual deposit rebate ' ,
        payChannel14: ' Manual Score Up - Deposit Offer' ,
        payChannel15: ' Manual score - other' ,
        payChannel16: ' Manually add bonuses' ,
        payChannel17: 'Event prize money' ,
        payChannel18: ' Manual bonus bonus - manual deposit rebate ' ,
        payChannel19: ' Manual Dividend Bonus - Deposit Offer' ,
        payChannel20: ' Manual Dividend Bonus-Promotions' ,
        payChannel21: ' Manual Score-Other Bonuses' ,
        payChannel22: 'Numerical currency offers up points' ,
        payChannel23: 'Relief bonus points' ,
        payChannel24: 'relief bonuses' ,
        payChannel25: 'Daily check-in score' ,
        payChannel26: 'National rebate' ,
        payChannel27: 'other' ,
        payChannel28: 'Interest deposit' ,
        payChannel29: 'Interest Treasure Principal Withdrawal' ,
        payChannel30: 'Interest withdrawal from interest treasure' ,

        payChannel31: 'Information Authentication' ,
        payChannel32: 'Weekly Rewards' ,
        payChannel33: 'Lucky Bet' ,
        payChannel34: 'Anniversary Gift' ,
        payChannel35: 'chess and card rewards' ,
        payChannel36: 'chess and card rescue' ,
        payChannel37: 'A thousand times a hundred times' ,
        payChannel38: 'One hundred million yuan in return' ,

        interestRecord1: 'hour' ,
        interestRecord2: 'take back' ,
        interestRecord3: 'early pick up' ,
        interestRecord4: 'In interest calculation' ,
        interestRecord5: 'Expired' ,
        interestRecord6: 'Received'
},
    activationRecord: {
        title: 'Activity Log' ,
        text1: 'The data of each activity will have a certain time delay, for reference only' ,
        text2: 'Event name:' ,
        text3: 'Please enter the event name' ,
        text4: 'Activity time:' ,
        text5: 'activity name' ,
        text6: 'Participation time' ,
        text7: 'operation' ,
        text8: 'check the details'
},
    highRebate: {
        title: 'National rebate' ,
        text1: 'Accumulated rebate:' ,
        Vnum: 'Total number of members:' ,
        effectiveVnum: 'Valid member:' ,
        text2: 'meta' ,
        text3: 'full' ,
        getConditions2: 'yuan, and valid membership ≥' ,
        getConditions3: 'People can get it' ,
        text5: 'receive' ,
        text6: 'member' ,
        text7: 'My Promotion Code' ,
        text8: 'Download promo code' ,
        text9: 'My invitation code' ,
        text10: 'Copy invitation code' ,
        text11: 'My promotion address' ,
        text12: 'Copy address' ,
        text13: 'rule description' ,
        text14: 'Invite members' ,
        text15: 'Total bet:' ,
        text16: 'Accumulated total rebate:' ,
        text17: 'Registration time:' ,
        text18: 'Time filter:' ,
        text19: 'member account' ,
        text20: 'Registration time' ,
        text21: 'Total effective bet (yuan)' ,
        text22: 'Rebate (yuan)' ,
        text23: 'Receive rebate' ,
        text24: 'meta' ,
        text25: 'Flow requirements:' ,
        text26: ' times ' ,
        text27: 'Cancel' ,
        text28: 'Get it now' ,
        messageErr1: 'The claim requirement is not met, the minimum claim amount' ,
        messageErr2: 'yuan, the number of valid members ≥' ,
        messageErr3: 'person, receive the upper limit' ,
        text30: 'Received successfully!'
},
    interest: {
        title: 'Interest Treasure' ,
        text1: 'deposit' ,
        text2: 'APR:' ,
        text3: 'Open range:' ,
        text4: 'View interest treasure records >' ,
        text5: 'Total deposit:' ,
        text6: 'meta/restoreable' ,
        text7: 'meta' ,
        text8: 'Number of deposits:' ,
        text9: 'pen/reloadable' ,
        text10: 'pen' ,
        text11: 'Deposit amount:' ,
        text12: 'Single minimum amount:' ,
        text13: 'meta' ,
        text14: 'Expected maximum rate' ,
        text15: 'Maximum interest rate:' ,
        text16: 'meta' ,
        text17: 'Purchase Rate Description' ,
        text18: 'deposit' ,
        text19: 'meta' ,
        text20: 'Maximum APR' ,
        text21: 'hour' ,
        text22: 'APR' ,
        text23: 'Deposit now' ,
        text24: 'Deposit successful' ,
        text25: 'Congratulations, the deposit operation is completed! You can check the betting details and bonus information in the interest treasure record ! ' ,
        text26: 'understood' ,
        text27: 'all' ,
        text28: 'in progress' ,
        text29: 'Not open' ,
        text30: 'closed' ,
        text31: 'The input amount does not meet the minimum amount! ' ,
        text32: 'The input amount cannot be greater than the re-deposit amount! ' ,
        text33: 'The amount of a single transaction exceeds the upper limit! ' ,
        text34: 'Insufficient number of re-deposits! ' ,
        text35: 'The deposit amount cannot be empty! ' ,
        text36: 'Not open' ,
        text37: 'Deposit to increase yield' ,
        text38: 'in progress' ,
        text39: 'Deposit to increase yield' ,
        text40: 'end application' ,
        text41: 'View' ,
        text42: 'End of interest calculation' ,
        text43: ''
},
    download: {
        text1: ` ${ skin } APP download` ,
        text2: ` ${ skin } Download on PC` ,
        text3: ` ${ skin } The client includes popular types such as real people, slot machines, fishing, arcade games, sports events, chess and cards, allowing you to enjoy the exciting games anytime , anywhere! ` ,
        text4: 'Android/IOS client' ,
        text5: 'No more hijacking, safe and stable, always protected, free to play! ' ,
        text6: 'Support Windows 7 and above operating systems' ,
        text7: 'PC version download' ,
        text8: 'PT PC version download' ,
        text9: 'The download channel is not open yet! ' ,
},
    //warp page (header of home page)
    warp: {
        chinese: 'Chinese' ,
        pc: "PC version" ,
        help: "Newbie Help" ,
        memberRegister: 'Free account opening' ,
        hello: 'hello' ,
        balance: 'balance' ,
        money: 'funding' ,
        memberDeposit: 'Member Deposit' ,
        memberWithdraw: 'Member Withdrawal' ,
        // transfer: "Internal transfer",
        message: "Site letter" ,
        sign: "Sign in" ,
        logout: "exit" ,
        index: 'Home' ,
        live: 'Live Video' ,
        egame: "electronic games" ,
        sport: " Sports Esports " ,
        chess: "chess game" ,
        lottery: "lottery game" ,
        fish: 'fishing game' ,
        discount: "Promotions" ,
        service: "Online Customer Service" ,
        download: "download" ,
        cooperation: "Cooperation Zone" ,
        warpBottom1: 'Cooperative Institution' ,
        warpBottom2: `About ${ skin } ` ,
        warpBottom3: "Gambling Responsibility" ,
        warpBottom4: "Rules and Statements" ,
        warpBottom5: "License Display" ,
        warpBottom6: "Frequently Asked Questions" ,
        warpBottom7: "VIP Club" ,
        clearCache: "Clear cache" ,
        advice: 'It is recommended to use IE9+ browser, Google browser, Firefox browser, it will give you a better experience! ' ,
        tbh: ` ${ skin } ` ,
        right: 'Copyright' ,
        selfHelp: 'self-service'
},
    //basic page
    base: {
        changePsw: 'Change password' ,
        safetyLevel: 'Account Security Level' ,
        phoneBind: "Mobile phone binding" ,
        emailBind: "Email binding" ,
        moneyPsw: "Fund Password" ,
        bankcardBind: "Bind bank card" ,
        vipLevel: "Member VIP Level" ,
        commonUser: "Ordinary User" ,
        distance: 'distance' ,
        short: "not yet" ,
        yuan: 'meta' ,
        system: 'The system will be in' ,
        nextWeek: "next Monday at 0:00" ,
        clear: "Automatically clear this week's bets and re-accumulate" ,
        open: "open" ,
        lowLevel: 'low-level' ,
        middleLevel: 'medium' ,
        highLevel: 'Advanced' ,
        experience: 'experience value' ,
        toppest: 'Currently at the highest level'
},
    //account page (profile)
    account: {
        title: "Complete Profile" ,
        account: "Login Account" ,
        realName: "real name" ,
        realNameP: 'Please enter the real name of your commonly used bank card' ,
        nickname: 'User Nickname' ,
        phone: 'mobile number' ,
        qq: 'Contact QQ' ,
        birthday: 'member birthday' ,
        qqP: "Please enter your frequently used QQ" ,
        wechat: " Contact WeChat " ,
        wechatP: "Please enter your usual WeChat " ,
        email: "Member Email" ,
        emailP: "Please enter your usual email address (note: email address can help you retrieve your login password)" ,
        confirm: 'Sure'
},
    'help' : {
        'titel1' : `About ${ skin } ` ,
        'titel2' : ` ${ skin } was established in 2009 and holds an online gaming operation license issued by the Philippine government. It is also an online gaming website with a legal gaming license formulated by the Online Gaming Commission. The company has technical cooperation with Asia Gaming, Boeing (BBIN), PT (PlayTech) and MG (MicroGaming) to jointly create a high-quality gaming platform with absolute legitimacy and fairness. To provide our customers with a variety of gaming activities, and provide generous rewards. ` ,
        'titel3' : 'Management with integrity' ,
        'titel4' : 'The company strictly abides by the gaming code stipulated by the Philippine government and is based on "sincerity". 100% credit guarantees that the game is fair and just. Each of your deposits and withdrawals will be completed safely and quickly after being reviewed' ,
        'titel5' : 'Fair and just' ,
        'titel6' : `The croupiers in live entertainment are subject to strict professional training and certification of international casinos, and all games respond according to the croupier 's actions, rather than the uninteresting computer odds preset results. We use high-tech webcasting technology to bring you the exciting experience of the casino. Electronic games use the fairest random number generation probability, allowing you to enjoy diverse and dazzling entertainment games with peace of mind.`,
        'titel7' : `Security and Privacy` ,
        'titel8' : `For the customer's network security, the company established a network security maintenance center and obtained the GEOTRUST international certification to ensure the fairness and impartiality of the website. In game betting, we use 128-bit SSL encryption transmission system, and MD5 encryption protection provides further protection for game platform and customer information. We promise that we will continue to spare no effort to strictly implement the confidentiality and privacy system to ensure the security of personal information and to ensure that your information will not be disclosed to any party. `,
        'titel9' : 'Friendly and professional customer service team' ,
        'titel10' : 'Our friendly and friendly customer service specialists are well-trained and can provide you with the most superior and personal service while helping to solve customer problems. We also have an online chat function, so that customers can contact us instantly. ' ,
        'titel11' : 'Frequently Asked Questions' ,
        'titel12' : ` One . ${ skin } Register` ,
        'titel13' : `1. How to register ${ skin } real money account? ` ,
        'titel14' : `Click the "Free Account" button in the upper right corner of the webpage, fill in the real and effective information according to the requirements of the pop-up page, and the ${ skin } background system will automatically generate an account. If you have any questions during this process, please contact ${ skin } customer service immediately. ` ,
        'titel15' : `2. How to log in to the ${ skin } game? ` ,
        'titel16' : `You can log in to the official website or through the client, log in to the game page of ${ skin } . ` ,
        'titel17' : '3. Have you tried it out? ' ,
        'titel18' : 'We provide a free trial account to let you know and familiarize yourself with our game platform and game types. If you are satisfied with our game platform, you can deposit to play for real money. (Remarks: The trial bonus is for trial play only and does not participate in withdrawal)' ,
        'titel19' : `3. Why can't I browse the ${ skin } website normally` ,
        'titel20' : ` The ${ skin } website may cause you to be unable to browse the website normally when the interference of factors cannot be resisted. In this case, please contact the ${ skin } customer service staff immediately. ` ,
        'titel21' : `4. ${ skin } Customer game age limit` ,
        'titel22' : ` ${ skin } The minimum age limit for real money accounts is 21 years old. Anyone under the age of 21, ${ skin } refuses to register! ` ,
        'titel23' : `Two. ${ skin } Account` ,
        'titel24' : '1. How to change registration information' ,
        'titel25' : ` ${ skin } must be registered with your real name. Once the registration is successful, the name and account number cannot be changed; the bank card information and password can be changed by yourself in the [Member Center]. If you encounter any problems during this process, you can contact ${ skin } Customer service. ` ,
        'titel26' : '2. What should I do if I forget my password? ' ,
        'titel27' : ` ${ skin } has a total of 2 passwords. One is your login password to enter the website or game, and the other is the security password used when withdrawing money. ` ,
        'titel28' : 'A. Forgot the login password: Click "Forgot Password" in the upper right corner of the website:' ,
        'titel29' : '1. Reset the login password by entering a secure password' ,
        'titel30' : '2. Reset the login password through the email address bound to your registration information;' ,
        'titel31' : '3. Retrieve the login password through the mobile phone bound to your game account;' ,
        'titel32' : 'B. Forgot security password:' ,
        'titel33' : '1. Please log in to your account first, enter [Member Center] > [Security Management] > [Security Password], and reset the security password by setting security questions;' ,
        'titel34' : '2. Reset the security question and password through the mobile phone bound to the game account. ' ,
        'titel35' : '3. How to complete the deposit' ,
        'titel36' : 'A. deposit' ,
        'titel37' : `After you have successfully registered an account, you can start the deposit business. So far, ${ skin } accepts: "Scan QR Code Payment", "Online Payment", "WeChat Payment", "Alipay Transfer", and "Online Bank Transfer/ATM and Counter" and other deposit methods. Please choose the most suitable deposit method according to the actual situation. ` ,
        'titel38' : 'B. How soon after making a deposit can I be added to my account? ' ,
        'titel39' : `According to the different deposit methods you choose, the time for the amount to arrive will vary, but generally it will arrive immediately. If you have any questions, please contact ${ skin } customer service. ` ,
        'titel40' : 'C. Are there any wagering requirements after depositing? ' ,
        'titel41' : 'After you complete the deposit, if you have not claimed any bonus, you only need to complete the bet amount that is double the deposit amount to apply for withdrawal. ' ,
        'titel42' : '4. How to complete the withdrawal' ,
        'titel43' : 'A. Withdrawal' ,
        'titel44' : 'After your account has completed all the betting requirements, you can submit the application after filling in the information in the [Member Withdrawal] of the [Financial Center], and the relevant department will process it for you immediately; when applying for withdrawal, please be sure to fill in the real bank information. Withdrawals are generally available within 5 minutes. ' ,
        'titel45' : 'B. Why was the withdrawal rejected? ' ,
        'titel46' : `After the withdrawal business is returned by the relevant department of ${ skin } , please contact the customer service of ${ skin } immediately for consultation. ` ,
        'titel47' : '5. How to transfer money domestically? ' ,
        'titel48' : 'After logging in to the account, click "Funds - Indoor Transfer" in the upper right corner of the computer web version, click "Transfer" at the bottom of the home page for the mobile web version , select the corresponding game hall, select "Transfer to the game platform" when playing, and select "Transfer to the game platform" when withdrawing money Transfer to Master Account". ' ,
        'titel49' : `Three. ${ skin } game` ,
        'titel50' : `1. How many games does ${ skin } offer? ` ,
        'titel51' : ` ${ skin } currently provides multi-platform high-paying games, including:` ,
        'titel52' : '2. What should I do if it is very slow to enter the game? ' ,
        'titel53' : 'If you enter our website or the game is too slow, we recommend that you clear the cache! The steps for IE and 360 browsers are: ' ,
        'titel54' : '1. Please exit our website first. ' ,
        'titel55' : '2. Click "Tools" in the upper right corner of the browser, select "Internet Options", then click "Delete", check "Cookies and Website Data" and click Delete, wait for the deletion to complete, please try to enter the game again! ' ,
        'titel56' : `About 3. What should I do if the video cannot be displayed in the game? ${ skin } ` ,
        'titel57' : 'It is suggested that you can clear your FLASH cache, please click this link URL:' ,
        'titel58' : `Then click 'Remove All WEB Sites'. Click "Confirm" in the pop-up window to complete the operation!`,
        'titel59' : '4. Can the mobile phone play games? ' ,
        'titel60' : 'Currently the website supports Android and iPhone, you can use web games or download client games. However, even in the WIFI environment, the current operating capability of the mobile phone processor is still limited, and sometimes the screen freezes. So it is recommended to use the computer to run the game! ' ,
        'titel61' : '5. How to generate game results and ensure the fairness of the game? ' ,
        'titel62' : ` ${ skin } All game results are generated by the game provider, the game results are real and valid, and ${ skin } will be responsible for all game results. The dealers in the live entertainment have received strict professional training and certification of international casinos, and all games respond according to the dealer's actions, rather than the uninteresting computer probability preset results. Electronic games use the fairest random number generation probability, allowing you to enjoy diverse and dazzling entertainment games with peace of mind. ` ,
        'titel63' : '6. How to place bets, cancel bets, and check game records? ' ,
        'titel64' : ` ${ skin } All game bets have a prominent bet button on the game page, you can bet according to your betting habits. Slot games cannot be revoked. Once clicked, the game will start automatically, please click properly. Live or sports games have the option to cancel bets until the bet is not accepted. All game records can be queried in the game page menu. If you have any questions, please feel free to contact ${ skin } customer service. ` ,
        'titel65' : '7. Why is the effective bet amount in the betting record inconsistent with your statistics? ' ,
        'titel66' : 'The AG platform and the Boeing platform both use the US Eastern Time (US Eastern Time such as: New York, Washington time), so the time in the betting record will be different from the actual betting time. For example, if the actual betting time is 20:00 in the evening, the time displayed on the record is 8:00 in the morning, and there is a 12-hour time difference. The Greenwich Mean Time used by MG is 8 hours different from Beijing time. ' ,
        'titel67' : '8. Are live-action games real-time games? Is the game page fake? ' ,
        'titel68' : ` ${ skin } The live game providers are Playtech, AG, Microgaming, BBIN, and all their live games are real-time games. The TV next to the PT table broadcasts the programs of CNN TV in the United States or other famous TV stations that are synchronized globally. In addition, you can chat with the live dealer at any time; AG, you can make real-time calls by dialing the Philippine phone on the desktop. ` ,
        'titel69' : '9. What should I do if the game suddenly stops and encounters an emergency? ' ,
        'titel70' : ` ${ skin } The game has been continuously improved and has become a very stable game environment in the same industry. However, due to the interference of many uncontrollable factors such as the international network, the country where the customer is located, etc., the game may be suddenly interrupted. If you encounter such problems, please do not panic and immediately contact the customer service staff of ${ skin } for assistance. Here , ${ skin } solemnly promises that ${ skin } will be responsible and compensate for any game losses caused by $ { skin } ! . ` ,
        'titel71' : `Four. ${ skin } Betting and Bonus Requirements` ,
        'titel72' : `1. ${ skin } how to get bonuses` ,
        'titel73' : ` ${ skin } provides many opportunities to obtain preferential bonuses. Some bonuses are automatically added to your account without applying for them. Other bonuses require you to apply and are automatically added for you after passing. ` ,
        'titel74' : '2. Can the bonus be cancelled? ' ,
        'titel75' : 'Once a bonus has been earned on your account, it cannot be cancelled. ' ,
        'titel76' : '3. Is it possible to withdraw money without completing the wagering requirements? ' ,
        'titel77' : ` ${ skin } All real money accounts are not allowed to withdraw money until the corresponding bonus wagering requirements have been completed. If your account balance is less than 5 RMB, all previous wagering requirements will be automatically cleared. ` ,
        'titel78' : 'Contact us' ,
        'titel79' : ` ${ skin } Customer Service` ,
        'titel80' : ` ${ skin } The customer service department is the designated customer service department. The nature of the customer service department is 24-hour online service. Its service communication channels include "online customer service", "hotline", "QQ customer service" and "complaints and suggestions". If you encounter any problems in the ${ skin } game, you can contact the customer service staff for help in the following ways, and the professional 24-hour customer service staff of the customer service department will serve you wholeheartedly! ` ,
        'titel81' : 'Warm reminder:' ,
        'titel82' : `The following contact information is the designated service channel for ${ skin } . If you encounter a case of impersonation, forgery or unverified communication, please do not believe any of its contents, and please contact our customer service staff to verify or report the situation in time! Hereby declare that if the customer suffers any loss in the false service, the company will not be responsible for it! Thank you for your support and understanding! ` ,
        'titel83' : 'Online chat contains:' ,
        'titel84' : '1. Official online customer service. ' ,
        'titel85' : '2. Marketing QQ customer service: 1579010. ' ,
        'titel86' : '2. Official hotline: 0063-9695-600000' ,
        'titel87' : '3. Suggestion and complaint email: cs@sanos8888.com' ,
        'titel88' : 'Rules and Statements' ,
        'titel89' : `The company is a legal Internet trading organization, and customers who intend to participate in all the company's games are reminded that they should pay attention to the relevant laws and regulations of their country or region of residence. If in doubt, they should seek local legal advice on relevant issues. These terms cover all agreements between you and the company when gaming on this website.`,
        'titel90' : '1. Statutory requirements' ,
        'titel91' : 'Under the laws of your country of residence, you must be of legal age to use this website. ' ,
        'titel92' : 'If you are under the age of 21, you may not use this website under any circumstances . ' ,
        'titel93' : ' The legality of online gambling has not been clarified in the laws of some regions or countries, and even some regions or countries have clearly regulated online gambling as an illegal act. We do not intend to invite anyone to use this site illegally in these regions or countries. The existence of this website does not imply that we promote online gambling in any region or country where gambling is illegal. You must be solely responsible for determining whether the use of online gambling is legal in the region or country where you live. ' ,
        'titel94' : '2. Account regulations' ,
        'titel95' : `The customer can only have one account. If it is found that the customer has multiple accounts, the company has the right to freeze the customer's account and cancel all winning bets in the account. The company reserves the right to reserve the right to cancel any amount that causes the account balance to be incorrect. In addition, if it is found that the account holder and relatives share multiple different accounts, the company reserves the right to restrict each customer to keep a maximum of one account. If the above situation has constituted fraud, harm or infringement of the rights or interests of the company and other users, the company has the right to demand compensation from the user and confiscate the balance in the user 's account , and terminate or cancel the user's right to continue to use the system`,
        'titel96' : '3. Transaction settlement' ,
        'titel97' : 'Users are responsible and obliged to check their account balance before or after each game transaction and before leaving the game. When the user suspects that the balance is wrong, he must file a complaint with the online customer service staff of this website or the customer service department of the company before the next round of the game (the start of the game and the appearance of the checkout screen are regarded as one round). If you do not do so, the company will consider that you have waived your right to appeal and accept the current balance data as correct. ' ,
        'titel98' : 'For users who settle transactions directly with the company, the bank account name must be the same as the name used in the membership registration and application process. If the user uses a credit or debit card, the cardholder name must also be the same as the name used during the membership registration and application process. In the event that the bank account name or cardholder name is inconsistent with the name used for account registration (member registration), the company reserves the right to refuse the settlement of related transactions' ,
        'titel99' : 'For users who settle transactions directly with the company, the company will deposit the gaming income into your user account according to the transaction method information provided by the user . In the process of depositing any money or income into the account, if there is a transaction error due to insufficient information or incorrect information provided by the user, the company shall not be liable in any form. Once the user finds that the funds in the account are incorrect, it is the responsibility of the user to notify us immediately. ' ,
        'titel100' : `The company has the right to deduct and deduct the above-mentioned fees from the user's account balance for the bank fees incurred by the company due to the user's settlement transaction, including handling fees, telegraphic postage, etc.` ,
        'name1' : 'JACKPOT will deduct a certain prize pool management fee according to the specific winning amount after winning the lottery , which is based on the amount charged by the game platform company. ' ,
        'name2' : '4. The rights and obligations of the company' ,
        'name3' : `The company will take various measures to protect the security of players' accounts.`,
        'name4' : 'The company will never use any artificial means to affect the fairness of the game. ' ,
        'name5' : 'The company is not responsible for any illegal use of player accounts. ' ,
        'name6' : 'The company reserves the right to revise all systems and rules. ' ,
        'name7' : `If the company finds that players cheat, attack or destroy the normal operation of the system in the game, and use explicit or implied methods to slander, slander and intimidate " ${ skin } Casino" , slanderous behavior, after being dissuaded by the company, the company reserves all rights to refuse/prohibit and revoke the player's continued use of the system, "will be prosecuted in accordance with the laws of the Republic of the Philippines". ` ,
        'name8' : 'Our company has "backup data" for your personal data and records in the system. However, in the unfortunate event of irresistible factors (such as natural disasters, terrorist activities, wars, riots...) resulting in the loss of the above data, the company will do its best to restore all historical data, and the restored data will also be considered fair. ' ,
        'name9' : '5. Promotions and Offers' ,
        'name10' : 'All promotions, offers and special events are subject to these Terms and the rules and conditions set forth by the Company from time to time for specific promotions. The Company reserves the right to suspend, cancel or modify the terms and conditions of such promotions, incentives and special events at any time. ' ,
        'name11' : 'If the Company determines that there has been abuse or attempted abuse of a promotion or reward, or may benefit from such abuse, the Company reserves the right to block, reject, suspend or revoke any user in the manner it deems appropriate Participate in relevant promotions, incentives and special events. ' ,
        'name12' : '6. Terms modification policy' ,
        'name13' : 'The company reserves the absolute right to revise, update and modify these terms and game rules from time to time. Any revisions, updates and modifications will be posted on the official website. These Terms and Game Rules, as amended, updated or modified, will be effective upon publication. When the user continues to use the website or the game after the above revisions, updates and revisions are announced, it is deemed that the user agrees and accepts the revisions, updates and revisions of the company. ' ,
        'name14' : 'We recommend that you regularly read the rules and terms of this website and the rules of the game. ' ,
        'name15' : 'The above revisions, updates and modifications, the company can decide whether to notify the user or not. The company has no obligation to notify users of the above revisions, updates and modifications. ' ,
        'name16' : 'Member Deposit' ,
        'name17' : 'green channel' ,
        'name18' : ' Alipay to bank card' ,
        'name19' : ' UnionPay scan code ' ,
        'name20' : 'Gambling Responsibility' ,
        'name21' : 'License Display' ,
        'name22' : 'Anti-hijacking help' ,
        'name23' : 'Deposit Demo' ,
        'name233' : 'Withdrawal Demo' ,
        'name24' : ' 1. Anti-hijacking instructions' ,
        'name25' : 'If you use a mobile device to access the address of our website, open the page and jump to another website. How should it be handled? ' ,
        'name26' : 'This is a case of DNS hijacking. DNS is referred to as domain name hijacking, which means that cyber hackers have exploited the vulnerability of the server, changed the original IP of your domain name, and then jumped to other fake websites. It may cause you to make mistakes and even endanger the security of your account and property. ' ,
        'name27' : '2. Operating Instructions' ,
        'name28' : 'Android client' ,
        'name29' : 'IOS client' ,
        'name30' : ` ${ skin } is an organization with legal business rights in the Philippines, which ensures the fairness and legitimacy of ${ skin } 's operations, thus ensuring the fairness, justice and financial security between customers and ${ skin } ! PT Games are deployed by PT TransPacific under license from PAGCOR. ` ,
        'name31' : 'CEZA Certification' ,
        'name32' : 'PAGCOR Certification' ,
        'name33' : 'License number OGL16-0014' ,
        'name34' : 'Under Gaming Age' ,
        'name35' : `The company is a legal Internet trading organization, and customers who intend to participate in all the company's games are reminded that they should pay attention to the relevant laws and regulations of their country or region of residence. If in doubt, they should seek local legal advice on relevant issues. These terms cover all agreements between you and the company when gaming on this website. `,
        'name36' : ` ${ skin } Casino actively promotes responsible gaming and strongly refuses underage players to use our software for online entertainment. At the same time, we use professionals and various effective methods to prevent the occurrence of problem gambling. We will forfeit all winnings and reserve the right to terminate the customer's betting account immediately upon discovery that the customer using this website is under the age of 21. ` ,
        'name37' : ' This service is not available to anyone under the age of 21. The data provided by all persons using this service indicates that they are over the age of 21. If the company recognizes that a person under the age of 21 attempts or has provided data to this website, the company will not accept their data and take action to clear their data. ' ,
        'name38' : 'If your computer is used by persons under the age of 21, we recommend that you set the computer data privacy to prevent account number/username from being stolen. ' ,
        'name39' : 'Gambling Behavior Review' ,
        'name40' : 'Gambling is just entertainment, most players regard gambling as entertainment. However, a small number of players cannot control themselves and are addicted to gambling, often causing harm to themselves and society. The following is a gaming problem test prepared for players, you can test whether you are facing the following problems. ' ,
        'name400' : '1. Are you absent from work or school because of gambling? ' ,
        'name41' : '2. Do you gamble to escape boredom or an unpleasant life? ' ,
        'name42' : '3. When you run out of money gambling, do you feel disappointed or even hopeless and wish to gamble again soon? ' ,
        'name43' : '4. Do you gamble until the last penny? ' ,
        'name44' : '5. Have you ever lied to cover up the time and money you spend on gambling? ' ,
        'name45' : '6. Do you gamble because of arguments, frustration or disappointment? ' ,
        'name46' : '7. Have you ever felt lost or even committed suicide because of gambling? ' ,
        'name47' : '8. Have you lost interest in your family, friends or hobbies? ' ,
        'name48' : '9. After you lose, do you immediately want to win back the money you lost? ' ,
        'name49' : `The more 'yes' you answer to these questions, the closer you are to having a serious gaming problem.`,
        'name50' : 'In order to help you decide whether the restrictions set are appropriate for you, please consider carefully:' ,
        'name51' : '1. Make an acceptable winning and losing limit before you start gambling' ,
        'name52' : '2. Pay attention to how much time you spend in betting games' ,
        'name53' : '3. Make a daily, weekly or monthly betting amount according to your actual situation' ,
        'name54' : 'Responsibility and Integrity' ,
        'name55' : ` ${ skin } Casino is committed to improving service standards, and promises to fulfill the greatest degree of responsibility to customers, including integrity, transparency, legality and other aspects. If customers encounter any problems related to responsible gaming, they can contact our customer service department 24 hours a day. We promise to provide users with technical support and related question answering services 365 days a year. ` ,
},
    'helpamjs' : {
        'title0' : `About ${ skin } ` ,
        'titel1' : ` ${ skin } is registered in Manila, Philippines, holds a sports betting and online casino license issued by the First Cagayan Leisure and Resort Corporation of the Philippine Government Cagayan Special Economic Zone, and is authorized and regulated by the Philippine government and the Cagayan Special Economic Zone CEZA. All gaming operations are in compliance with the Philippine Government Gaming Treaty. In the increasingly competitive online gaming market, we are constantly seeking innovations, looking for the latest ideas, and adhering to the best services. To provide customers with high-quality services, advanced products, rich entertainment experience, is our eternal purpose of ${ skin } . ` ,
        'titel2' : `We think about what you want and provide high-standard and comprehensive personal privacy and confidentiality measures as well as a high-strength financial security system. Players' online payment and all banking transactions will be conducted by international financial institutions through a high-standard secure and confidential network port (SSL 128 bit encryption Standard). Entering the player account data must also have the player's unique login ID and password to ensure that the customer's funds are safe and secure. At the same time, the most advanced encryption measures are used to ensure the safety of players' games, and 7×24 hours of background detection and monitoring ensure that we can provide a completely fair and safe online game space. All activities of customers on this platform are strictly confidential, and we will never disclose customer data to third parties (including relevant units).`,
        'titel3' : 'We promise you:' ,
        'titel4' : 'Integrity-based' ,
        'titel5' : 'As an international professional online gaming operator, we promise to provide every customer with the safest and fairest gaming games and a full range of services. ' ,
        'titel6' : 'Provide the most diverse and realistic games' ,
        'titel7' : 'The dealers in our live video are professionally trained by international casinos, professional, efficient and rigorous! Each hand is dealt by the dealer in real time, not the pre-set computer probability result. Through high-tech webcasting technology, it will bring you the exciting experience of being in the casino scene!' ,
        'titel8' : 'Our sports betting has top-level trading room operators, investing a lot of manpower and resources in order to bring complete events and rich gameplay to sports-loving players. ' ,
        'titel9' : 'All kinds of lottery games are based on the game results generated by the official results , allowing players to enjoy the most authentic entertainment in the lively betting interface. ' ,
        'titel10' : `Our video game is jointly developed with the world's top video game development team, using the most advanced animation visual effects, using the fairest random number generation probability, allowing you to enjoy diverse, exciting, and visually rich video games with peace of mind.`,
        'titel11' : 'All the games of our company have common advantages: no need to download, simple interface, complete functions, exquisite graphics, and the game is fair, just and open!' ,
        'titel12' : 'Provide excellent customer service' ,
        'titel13' : `We have a customer service team selected with the highest standards and the most rigorous training to provide you with real-time online customer service 365 days x 24 hours. Each player's consultation will be answered in a professional and cordial manner, and will help you solve problems while bringing you a home away from home experience! Provide multi-channel interaction with customers, understand customer needs, and pay attention to customers' opinions at any time and suggestions; hold more offers and promotions to provide customers with more feedback and surprises.`,
        'titel14' : 'Efficient and secure deposits and withdrawals' ,
        'titel15' : 'We offer our members a variety of safe and easy deposit and withdrawal options. We have always adhered to the principles of "Know Our Member (KYC)" and Anti-Money Laundering (AML), and cooperated with third-party financial management authorities to ensure maximum compliance with relevant laws and regulations. ' ,
        'titel16' : 'We are very proud of the company we have built and want all users to enjoy and profit from our well-designed products and services in a safe and enjoyable environment. We provide the fastest and safest withdrawal method, and members can apply for withdrawal 365 days x 24 hours. ' ,
        'titel17' : 'Make you a big winner' ,
        'titel18' : 'We will continue to launch all kinds of discounts that are beneficial to new and old members, send surprises every day, give feedback every week, and give out every month, so that you can become a big winner. ' ,
        'titel19' : 'Actively participate in charity and public welfare' ,
        'titel20' : 'While we serve every member wholeheartedly, we also shoulder the responsibility to the society and charity. Taking it from the society and using it for the society is also one of the tenets we have been adhering to. We actively participate in various donation activities, and will never be forgotten to make more for the needs of the society. ' ,
        'titel21' : 'The company promotes controlled gambling. We recommend that you follow some basic rules:' ,
        'titel22' : '• Gambling games for persons under the age of 18 are prohibited. Please make sure you are over 18 years old before joining the game. ' ,
        'titel23' : '• Customize your gaming budget and bet on your budget. ' ,
},
    // Chess and card rewards
    Reward: {
        title: 'chess and card bonus' ,
        table1: 'date' ,
        table2: 'Complete the total number of rounds' ,
        table3: 'Effective bet amount' ,
        table4: 'Bonus' ,
        receive: 'receive' ,
        receive1: 'Received' ,
        receive2: 'Not met the conditions for receiving' ,
        footer1: 'Warm reminder:' ,
        footer2: '1. According to the total number of games completed by members on Kaiyuan Chess and Cards, 761 Chess and Cards, Three Kingdoms Chess and Cards, and Monopoly Chess and Cards platforms every day, and the total effective betting amount on the above-mentioned Chess and Cards platforms on that day is ≥ 1000 yuan, the corresponding rewards will be returned . Kim' ,
        footer3: '2. Before 16:00 every day, count the total number of rounds generated from 00:00-23:59:59 Beijing time yesterday. ' ,
        footer4: '3. Rewards for daily activities cannot be accumulated. If the user does not receive the reward on a certain day, it will be deemed that the reward has been given up automatically and will be reset to zero. ' ,
        footer5: '4. The event reward is not limited to games, and it only needs 1 times the turnover to withdraw. ' ,
        footer6: '5. Warm reminder: ' ,
        footer7: 'Click here to view' ,
        footer8: 'Chess and Card Bonus Offer Details' ,
        message1: 'Received successfully! ' ,
        message2: 'The reward has been received! ' ,
        text1: 'month' ,
        text2: 'day' ,
},
    //chess rescue
    Rescue: {
        title: 'chess and card rescue money ' ,
        table1: 'date' ,
        table2: 'Negative Profit' ,
        table3: 'Bonus' ,
        receive: 'receive' ,
        receive1: 'Received' ,
        receive2: 'Not met the conditions for receiving' ,
        footer1: 'Warm reminder:' ,
        footer2: '1. During the event, according to the daily negative profit of members in Kaiyuan/761/Three Kingdoms/Monopoly Chess and Cards, you can get the corresponding rescue money! ' ,
        footer3: '2. Event time: from 2018-08-01, valid for a long time' ,
        footer4: '3. Before 12:00 noon every day, count the negative profit generated from 00:00-23:59:59 Beijing time yesterday. ' ,
        footer5: '4. The rescue fund for daily activities cannot be accumulated. If the user does not receive the rescue fund on a certain day, it will be regarded as giving up the rescue fund automatically, and it will be cleared and counted again on the next day. ' ,
        footer6: '5. Warm reminder: ' ,
        footer7: 'Click here to view' ,
        footer8: 'Details of Chess and Card Rescue Funds ' ,
        message1: 'Received successfully! ' ,
        message2: 'The reward has been received! ' ,
        text1: 'month' ,
        text2: 'day' ,
},
    //Self-service discount---Anniversary gift + thousands of times the page
    Anniversary: {
        tip1: 'Reminder: If your accumulated deposit does not reach 1 yuan before the start of the anniversary gift collection day, you will not be able to get this promotion! ' ,
        tip2: 'Issue time: from the date of the first deposit, and after every full year , it will be distributed at 1:30 am on the next day! ' ,
        tip3: 'Participation conditions are not met, no first deposit ' ,
        tip4: 'receive' ,
        tip5: 'Received' ,
        tip6: '[View offer details]' ,
        tip7: 'Congratulations on your successful claim' ,
        tip31: 'Reward, please pay attention to account balance changes' ,
        tip8: 'Warm reminder: Only one thousand times the bonus can be claimed once a day (00:00 to 23:59:59 on the same day)! (If you submit wrong information more than 5 times, you will be disqualified from applying on the same day)' ,
        tip9: 'A thousand times a thousand times' ,
        tip10: 'Game Platform' ,
        tip11: 'game time' ,
        tip12: 'Bet Amount' ,
        tip13: 'Winning multiple' ,
        tip14: 'get bonus' ,
        tip15: 'Notes' ,
        tip16: 'operation' ,
        tip17: 'Apply for award' ,
        tip19: 'No winning record' ,
        tip20: 'Warm reminder' ,
        tip21: 'If there is a network factor that does not display the currently matched bet, please refresh the network and try again later or click the self-service submission below' ,
        tip22: '*CQ9, DT, AE, TTG and other platforms, please click! ' ,
        tip23: 'Self-service submission of complaint suggestions. ' ,
        tip24: '1. When the total payout of the winning medal round is the investment amount' ,
        name2: 'Hundred times' ,
        name3: 'For the bonuses distributed at the time of the above, the members who meet the conditions can apply for it by themselves. ' ,
        tip25: '2. Event time: March 14, 2019 to June 1, 2020 (00:00:00-23:45:00). ' ,
        tip26: '3. Each user can only claim each day' ,
        name: 'Thousands of times the bonus, if it is not claimed on the day, it will be regarded as giving up the bonus automatically, and it will be cleared and re-stated the next day. ' ,
        tip27: '(Note: games such as fishing games, live dealers, video poker, arcade games, table games and scratch-off games in the platform are not included.)' ,
        tip28: '4. The event bonus is not limited to games, only 12 times the turnover can be withdrawn. ' ,
        tip29: 'Click here to view' ,
        tip30: 'Are you sure you want to apply for this bet reward' ,
        tip33: 'hint' ,
        tip32: 'OK' ,
        tip34: 'Cancel' ,
        tip35: 'Not meeting the collection conditions' ,
        tip36: 'No down payment' ,
        tip37: 'Anniversary Gift' ,
        tip38: 'Click close to return to the self-service lobby' ,
        tip39: 'First Deposit Date' ,
        tip40: 'Current VIP level' ,
        tip41: 'Pre-distributed Anniversary Gifts' ,
        tip42: 'here' ,
        tip43: 'Offer details. ' ,
        tip44: ' There is still time before the full year ' ,
        tip45: 'Warm reminder' ,
        tip46: 'No first deposit ' ,
        tip47: 'OK' ,
        tip48: 'Received' ,
},
    //Self-service discount - weekly attendance reward
    weekAward: {
        title: "Weekly Reward" ,
        topTips: "Reminder: Statistics update the effective betting amount of the previous day at 14:00 every day!" ,
        thisWeek: 'Weekly this week' ,
        lastWeek: ' Weekly statistics of last week ' ,
        thisTurnDayCount: 'Already attended this week' ,
        day: 'day' ,
        thisTotalEffeBetsAmount: 'Accumulated effective bet amount' ,
        yuan: 'meta' ,
        lookLastRecords: "[View last week's record]" ,
        lastTurnDayCount: 'Accumulated attendance days last week' ,
        lastTotalEffeBetsAmount: 'Effective betting amount accumulated last week' ,
        weekGift: 'Chou Qin gift money' ,
        seeGift: 'Reward List' ,
        keepOnFighting1: 'The distribution conditions were not met last week ' ,
        keepOnFighting2: 'Please keep working hard this week' ,
        keepOnFighting3: "You have reached the distribution conditions last week" ,
        keepOnFighting4: "Please be aware of balance changes" ,
        botTips: "Warm reminder:" ,
        botTip1: `1. Activity introduction: As long as ${ skin } members have made game bets for a total of four days within a week, and within these four days, the daily effective betting amount is not less than 300 yuan, and the weekly effective betting amount is not less than 5,000 yuan. You can get the corresponding weekly bonus! ` ,
        botTip21: "2. Release time:" ,
        botTip22: "Every Tuesday at 14:00" ,
        botTip23: 'Before, the system will complete' ,
        botTip24: 'last week' ,
        botTip25: 'Statistics of betting situation, members who meet the conditions will be in' ,
        botTip26: "Before 18:00" ,
        botTip27: ' issued by the system. ' ,
        botTip3: "3. [First Deposit Offer] and [Weekly Rewards] offer cannot be enjoyed in the same week and at the same time." ,
        botTip4: "4. It takes eight times the turnover to withdraw money." ,
        botTip5: `5. If there is a difference in the understanding of the text, the final interpretation right belongs to [ ${ skin } ], and [ ${ skin } ] has the right to change, end, shorten, and extend the activity. ` ,
        weekGiftTableLabel1: "Weekly Attendance (Single Day Bet>300)" ,
        weekGiftTabelLabel2: ' Weekly betting amount (yuan)' ,
        weekGiftTabelLabel3: 'Zhou Qin Gift (Yuan)' ,
        weekGiftCalcu: 'Weekly Attendance Rewards Calculation' ,
        lastWeekAwardCalcu: ' Weekly attendance record last week ' ,
        minSignDay: 'minimum' ,
        through: "to" ,
        unget: "Receive Rewards" ,
        geted: "Received"
},
    // Lucky bet
    luckyNote: {
        title: 'Lucky Bet' ,
        topTips1: 'Reminder: You can only receive daily (00:00 to 23:59:59 on the same day)' ,
        topTips2: 'Time Lucky Bet! Each bet number can only be applied once! (If you submit wrong information more than 5 times, you will be disqualified from applying on the same day)' ,
        platform: ' Video game platform ' ,
        gameTime: 'game time' ,
        betMoney: 'Bet Amount' ,
        luckyNoteNum: 'Lucky bet number' ,
        actGift: 'Event Rewards' ,
        operation: 'operation' ,
        apply: 'application' ,
        applied: "Applied" ,
        middleTips: 'If there is a network factor that does not display the currently matched bet, please refresh the network and try again later or click the self-service submission below' ,
        text1: "*Lucky bet single auto query" ,
        text2: "DT platform is not supported" ,
        text3: ", if necessary, please in" ,
        text4: "here" ,
        text5: 'self-submission' ,
        applyRecords: "Today's Application Record" ,
        clickThis: "Click here to view" ,
        luckyNotedetail: 'Lucky Bet Offer Details' ,
        applyTime: 'Application time' ,
        applyPlatForm: 'Application Platform' ,
        betNum: 'Bet slip number' ,
        awardMoney: ' Shuffle reward amount' ,
        effBetMoney: ' The valid bet amount of the shuffled code ' ,
        remarks: 'Notes' ,
        isConfirmApply: "Are you sure you want to apply for this bet reward?" ,
        confirm: 'confirm' ,
        cancel: 'Cancel' ,
        applySuccess1: 'Congratulations on your successful claim' ,
        applySuccess2: "Reward, please pay attention to account balance changes!" ,
        applyFail: 'Not meeting the collection conditions' ,
        emptyText1: "--no record--" ,
        emptyText2: "No data yet" ,

},
    //Information authentication
    credentials: {
        title: 'Information Authentication' ,
        name: 'Information Verification Bonus' ,
        bank1: 'Bank card verification' ,
        pawess: 'Secure Password Authentication' ,
        text1: 'History accumulated deposits' ,
        text2: 'meta' ,
        text3: 'Certification bonus (yuan)' ,
        text4: 'Users need to complete all the above certifications and pass the review before they can claim this bonus' ,
        text5: '[Perfect authentication]' ,
        text6: 'Not meeting the collection conditions' ,
        text7: 'hint:' ,
        text8: 'Warm reminder:' ,
        text9: '1. The user must complete all authentications and the cumulative deposit history is not less than' ,
        text91: 'After the yuan, the application conditions are met! ' ,
        text10: '2. Each account is only allowed to claim the information verification bonus once. ' ,
        text11: '3. If you have any questions about this, you can click to view' ,
        text12: 'Certification Bonus' ,
        text13: 'rule. ' ,
        failed: 'Not meeting the collection requirements' ,
        received: 'receive' ,
        receivedt: 'Received' ,
        'realName' : "name" ,
        'email' : "Bind Email" ,
        'phone' : "Bind phone number" ,
        'qq' : "Bind QQ number" ,
        'safePassword' : "Secure Password Verification" ,
        'bank' : "Bank Card Binding" ,
        'digitalCurrency' : "Bind digital currency" ,
        'origin' : "Bind Wallet" ,
        'deposit' : "Accumulated Deposit" ,

},
    // 100 million yuan feedback
    feedback: {
        title: 'One hundred million yuan in return' ,
        state: 'start date' ,
        storp: 'end date' ,
        table1: 'Payment flow' ,
        table2: 'profit and loss budget' ,
        table3: 'Reward Amount' ,
        table4: 'operation' ,
        tips: 'Warm reminder:' ,
        text1: 'If there is a network factor that does not display the currently matched bet, please refresh the network and try again later or click the self-service submission below' ,
        text2: 'Please click' ,
        text3: 'here' ,
        text4: 'Self-service submission of complaint suggestions. ' ,
        text5: `1. Activity object: All ${ skin } ordinary VIP and above members. ` ,
        text6: '2. 1 times the turnover of the reward received. ' ,
        text7: '3. Pickup time: on the 1st, 11th, and 21st of each month, you can get it. ' ,
        text8: `4. This event can be shared with all ${ skin } offers at the same time. ` ,
        text9: ` 5. All customers can only have one account: the same IP, the same deposit/withdrawal card, the same mobile phone number, and the same email address are regarded as the same customer. If it is found that the same person has two or more accounts, Duplicate accounts will be frozen, [ ${ skin } ] reserves the right to claim the rewards and profits of duplicate accounts. ` ,
        text10: '6. By participating in this promotion, you agree to the Promotion Rules and Terms. ' ,
        text11: 'Click here to view' ,
        text12: 'Offer details. ' ,

},

};

export default en;